const translations = {};

translations["MSG_GUIDE"] = "ガイド";
translations["MSG_NETWORK_ERROR_MESSAGE"] =
  "ページを ひょうじすることが できませんでした。\nもういちど ためしてみてください。";
translations["MSG_APP_ALL"] = "すべて";
translations["MSG_APP_BANNER_TITLE"] = "アプリ版『まなんでパズル』";
translations["MSG_APP_BANNER_SUBTITLE"] = "～子供も楽しくプログラミング教育～";
translations["MSG_APP_BANNER_INSTALL_BTN"] = "インストール";
translations["MSG_APP_BANNER_SHOW_BTN"] = "表示";

translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] = "アプリを最新版にアップデートします。";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "最新版のアプリがあります。\n最新の機能を利用する為にアップデートが必要です。\nアップデートはすぐに完了します。";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] = "6文字以上のパスワードを入力してください。";
translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "パスワードが一致していません。";
translations["MSG_SIGN_IN_BTN"] = "ログイン";
translations["MSG_SIGN_UP_BTN"] = "新規登録";
translations["MSG_SIGN_IN_WITH_APPLE"] = "Appleで続ける";
translations["MSG_SIGN_UP_WITH_APPLE"] = "Appleで続ける";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "Googleで続ける";
translations["MSG_SIGN_IN_WITH_MAIL"] = "メールでログイン";
translations["MSG_SIGN_UP_WITH_MAIL"] = "メールで登録する";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "アカウントがない方は新規登録";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "既にアカウントがある方はログイン";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "パスワードを入力してください";
translations["MSG_SIGN_LOGIN_FAILED"] =
  "ログインに失敗しました。メールアドレスとパスワードを確認してください。";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "パスワードが一致しません";
translations["MSG_SIGN_UP_FAILED"] = "アカウント作成に失敗しました。もう一度お試しください。";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "メールアドレスを入力してください";
translations["MSG_SIGN_EMAIL_INVALID"] = "有効なメールアドレスを入力してください";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] =
  "パスワードリセットメールの送信に失敗しました。もう一度お試しください。";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] =
  "※登録したメールアドレスにパスワードリセット用のリンクを送信します。";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "リセットメール送信";
translations["MSG_SIGN_EMAIL_SENT"] = "メールを送信しました";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] =
  "パスワードリセット用のリンクを送信しました。\nメールをご確認ください。";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "ログイン画面に戻る";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "名前は10文字以内で入力してください";
translations["MSG_USER_NAME_REQUIRED"] = "名前を入力してください";
translations["MSG_USER_LATEST"] = "最新";
translations["MSG_USER_LIST"] = "プレイヤー一覧";
translations["MSG_USER_START_LEARNING_MESSAGE"] =
  "お子様が学習を始めるために、\nまずはアカウントを作成してください。";
translations["MSG_USER_ADD_CHILD_ACCOUNT"] = "お子様のアカウントを追加";
translations["MSG_USER_START"] = "スタート";
translations["MSG_SIGN_USER_MAIL"] = "メールアドレス";
translations["MSG_SIGN_USER_PASSWORD"] = "パスワード";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "パスワード再入力";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "ログイン成功しました。";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "アカウント登録成功しました。";
// ReAuth
translations["MSG_REAUTH_TITLE"] = "本人確認";
translations["MSG_REAUTH_SSO_MESSAGE"] = "続けるにはもう一度ログインしてください";
translations["MSG_REAUTH_PASSWORD_RESET_CONFIRM"] =
  "パスワードリセットメールを以下のアドレスに送信します";
translations["MSG_REAUTH_BACK"] = "戻る";
// Common buttons
translations["MSG_BTN_LATER"] = "あとで";
translations["MSG_BTN_CLOSE"] = "閉じる";

// Restricted Feature Dialog (統合版)
translations["MSG_RESTRICTED_FEATURE_TITLE_COURSE"] = "コースは もうあそべない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_COURSE"] =
  "いまの プランでは アルゴリズムをあそぼうの ステージ1と2だけ あそべます。\nもっと あそびたいときは ほごしゃに そうだん してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_PROJECT_LIMIT"] = "アプリは もうつくれない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PROJECT_LIMIT"] =
  "いまの プランでは アプリは %{limit}こまで つくれます。\nもっと つくりたいときは ほごしゃに そうだん してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_LIMIT"] = "プレイヤーは ついかできない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_LIMIT"] =
  "いまの プランでは プレイヤーは %{limit}にんまで ついかできます。\nもっと ついかしたいときは ほごしゃに そうだん してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_ADD_TRIAL"] = "プレイヤーは ついかできない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_ADD_TRIAL"] =
  "たいけんプランでは プレイヤーを ついかできません。\nプレイヤーを ついかしたいときは ほごしゃに そうだん してください。";
translations["MSG_RESTRICTED_FEATURE_TITLE_PARENT_SETTINGS"] = "このプランでは つかえません";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PARENT_SETTINGS"] =
  "たいけんプランでは ほごしゃページに アクセスできません。\nほごしゃアカウントの とうろくが ひつようです。\nむりょうプランいじょうの プランから アクセスできます。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_CHAT_LIMIT"] = "きょうの AIチャットおわり";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_CHAT_LIMIT"] =
  "いまの プランでは 1にち %{limit}かいまで つかえます。\nきほんプランに アップグレードすると むせいげんで つかえます。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_IMAGE_LIMIT"] = "きょうの AIがぞうおわり";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_IMAGE_LIMIT"] =
  "いまの プランでは 1にち %{limit}かいまで つかえます。\nきほんプランに アップグレードすると むせいげんで つかえます。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHAT_IMAGE"] = "がぞうきのうについて";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHAT_IMAGE"] =
  "がぞうの そうしんは「とくべつプラン」で つかえます。\nとくべつプランに アップグレードすると、がぞうを おくることが できます。";
translations["MSG_RESTRICTED_FEATURE_TITLE_ASSET_LIMIT"] = "そざいは もうつかえない";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_ASSET_LIMIT"] =
  "いまの プランでは そざいは %{limit}こまで しよう できます。\nきほんプランに アップグレードすると むせいげんで しよう できます。";
translations["MSG_RESTRICTED_FEATURE_BTN_VIEW_PLANS"] = "プランを へんこう";
translations["MSG_RESTRICTED_FEATURE_BTN_TO_PARENTS"] = "ほごしゃの かたへ";

// Upgrade Promotion
translations["MSG_UPGRADE_PROMOTION_TITLE"] = "プランを へんこうして、 もっと たのしもう！";
translations["MSG_UPGRADE_PROMOTION_RECOMMENDED"] = "おすすめ";
translations["MSG_UPGRADE_PROMOTION_TABLE_PLAN"] = "プラン";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS"] = "プレイヤーすう";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_TRIAL"] = "1にん";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_FREE"] = "2にん";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_STANDARD"] = "4にん";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_PREMIUM"] = "8にん";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS"] = "さくひんすう";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_TRIAL"] = "1こ";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_FREE"] = "5こ";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_STANDARD"] = "10こ";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_PREMIUM"] = "10こ";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE"] = "AIがぞう";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_TRIAL"] = "1にち 1かい";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_FREE"] = "1にち 2かい";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_STANDARD"] = "1にち10かい";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_PREMIUM"] = "むせいげん\n（どうじ3まい）";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT"] = "まなパルくん";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_TRIAL"] = "1にち 4かい";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_FREE"] = "1にち 8かい";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_STANDARD"] = "むせいげん";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_PREMIUM"] = "むせいげん";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE"] = "データの\nほぞんようりょう";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_TRIAL"] = "100MB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_FREE"] = "1GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_STANDARD"] = "5GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_PREMIUM"] = "50GB";
translations["MSG_PLAN_CHANGE_BTN"] = "プランへんこう";
translations["MSG_UPGRADE_PROMOTION_CHANGE_BTN"] = "へんこう";
translations["MSG_UPGRADE_PROMOTION_TRIAL_DESCRIPTION"] =
  "アカウントとうろくすると、 かきんプランに もうしこめます";
translations["MSG_UPGRADE_PROMOTION_FREE_DESCRIPTION"] =
  "ほごしゃページで プランを へんこうできます";
translations["MSG_UPGRADE_PROMOTION_LATER_BTN"] = "あとで";
translations["MSG_UPGRADE_PROMOTION_SIGNUP_BTN"] = "アカウントとうろく";
translations["MSG_UPGRADE_PROMOTION_UPGRADE_BTN"] = "ほごしゃページへ";
translations["MSG_UPGRADE_PROMOTION_BTN_REGISTER"] = "とうろく";
translations["MSG_UPGRADE_PROMOTION_BTN_PURCHASE"] = "こうにゅう";

translations["MSG_SIGN_IN_FAILED_TITLE"] = "ログイン失敗";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "メールアドレスかパスワードが間違っています。";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "パスワードを忘れた場合";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "パスワードリセット";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "現在のパスワード";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "新しいパスワード";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] = "パスワードを確認";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "パスワード変更成功しました。";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] =
  "入力したパスワードが間違っています。";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "このメールアドレスは既に利用されます。";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "保護者";

translations["MSG_DATETIME_PERIOD"] = "きかん";
translations["MSG_DATETIME_PERIOD_RECENTLY"] = "さいきん";
translations["MSG_DATETIME_FORMAT_HOUR"] = "じ";
translations["MSG_DATETIME_FORMAT_MINUTE"] = "ふん";

translations["MSG_INEXUS_OFFICIAL"] = "まなんでパズル";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "まなパズサポート";
translations["MSG_AI_CHAT_SESSION_START"] = "セッションかいし";
translations["MSG_AI_CHAT_SESSION_END"] = "セッションしゅうりょう";
translations["MSG_REVIEW_RATING_TITLE"] = "『まなんでパズル』の\nひょうかを\nおしえてください！";
translations["MSG_REVIEW_FEEDBACK_TITLE"] = "ごいけんばこ";
translations["MSG_REVIEW_SEND_RATING_CONFIRM"] = "おくる";
translations["MSG_REVIEW_SEND_FEEDBACK_CONFIRM"] = "ごいけんを おくる";

translations["MSG_REVIEW_THANKS_BUBBLE_TEXT"] = "ありがとう\nございました！";
translations["MSG_REVIEW_FEEDBACK_THANKS_TEXT"] =
  "これからも、『まなんでパズル』を\nよろしくおねがいします。";

translations["MSG_REVIEW_FEEDBACK_TYPE_APP"] = "アプリぜんたい";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE"] = "『コースでまなぶ』";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR"] = "『じゆうにつくる』";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "ふまんはない";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "つかいかたが\nわからない";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "つかいづらい";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "むずかし\nすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "かんたん\nすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "ステージが\nおおすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "ステージが\nすくなすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] = "うまく\nつくれない";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "つかいかたが\nむずかしい";
translations["MSG_REVIEW_FEEDBACK_PLACEHOLDER"] = "ここにじゆうに かいてください";
translations["MSG_USER_PROFILE_ADD_USER_BTN"] = "ついか";
translations["MSG_USER_PROFILE_CHANGE_USER"] = "プレイヤーきりかえ";
translations["MSG_USER_PROFILE_CHANGE_USER_TITLE"] = "プレイヤーを きりかえますか？";
translations["MSG_USER_PROFILE_CHANGE_USER_MESSAGE"] = "「%{name}」に きりかえます。";
translations["MSG_USER_PROFILE_CHANGE_USER_SUCCESS"] = "プレイヤーを きりかえました。";
translations["MSG_USER_PROFILE_CHANGE_USER_FAILED"] = "プレイヤーの きりかえに しっぱいしました。";
translations["MSG_USER_PROFILE_MAX_USER_TITLE"] = "プレイヤーを ついかできません";
translations["MSG_USER_PROFILE_MAX_USER_MESSAGE"] =
  "いま つかっている プランでは プレイヤーを %{limit}にん まで つくれます\nあたらしい プレイヤーを つくるには いらない プレイヤーを けしてください";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_TITLE"] = "ここでは ついかできないよ";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_MESSAGE"] =
  "・プレイヤーの ついかは、ほごしゃの かただけが おこなうことが できます。\n・プレイヤーを ついかする ばあいは、ほごしゃの かたに ほごしゃページから ついかして もらってください。";
translations["MSG_USER_PROFILE_SHOW_USER_LIST_BTN"] = "もっと";
translations["MSG_USER_PROFILE_USER_STATUS"] = "ステータス";
translations["MSG_USER_SELECTION_PROMPT"] = "プレイヤーを　えらんでね";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "なまえ%{random}";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT"] = "なまえを つけてね";
translations["MSG_USER_PROFILE_FIELD_NAME"] = "ニックネーム";
translations["MSG_USER_PROFILE_FIELD_NAME_PLACEHOLDER"] = "ニックネームをいれてください";
translations["MSG_USER_PROFILE_FIELD_GENDER"] = "せいべつ";
translations["MSG_USER_PROFILE_FIELD_GENDER_MALE"] = "おとこのこ";
translations["MSG_USER_PROFILE_FIELD_GENDER_FEMALE"] = "おんなのこ";
translations["MSG_USER_PROFILE_FIELD_GENDER_NONE"] = "なし";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY"] = "たんじょうび";
translations["MSG_USER_PROFILE_EDIT_BTN"] = "へんこう";
translations["MSG_USER_PROFILE_STATUS_COURSE_CLEARED"] = "クリアした\nコース";
translations["MSG_USER_PROFILE_STATUS_PROJECTS"] = "つくった\nアプリ";
translations["MSG_USER_PROFILE_STATUS_PUBLISHED_PROJECTS"] = "こうかいした\nアプリ";
translations["MSG_USER_PROFILE_STATUS_PROJECT_RECEIVED_FAVORITE"] = "もらった\nいいねのかず";
translations["MSG_USER_PROFILE_PROGRESS"] = "きろく";
translations["MSG_USER_PROFILE_PROGRESS_NEW_TITLE"] = "New!";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_LEVEL_TITLE"] = "レベル";
translations["MSG_USER_PROFILE_PROGRESS_COURSE"] = "コースで\nまなぶ";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CHART_DATE_TITLE"] = "にちめ";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_TITLE"] = "クリアしたかず";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR"] = "じゆうに\nつくる";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_START"] = "ごうけい";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_END"] = "にん";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_START"] = "ごうけい";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_END"] = "いいね";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_VIEWED_TITLE"] = "みにきたひと";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_FAVORITED_TITLE"] = "いいねのかず";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY"] = "アプリをつくりましょう！";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_GOTO_BTN"] = "『じゆうにつくる』へ";

translations["MSG_USER_PROFILE_INFO"] = "じぶん";
translations["MSG_USER_PROFILE_ICON_BTN"] = "アイコンをへんこう";
translations["MSG_USER_PROFILE_CASE_BTN"] = "ケースをへんこう";
translations["MSG_USER_PROFILE_STOCK"] = "そざい";
translations["MSG_USER_PROFILE_SETTING"] = "せってい";
translations["MSG_USER_PROFILE_NAME_ERROR_TITLE"] = "とうろくが できませんでした。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_TITLE"] = "登録ができませんでした。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "使う事のできない文字や文章が含まれています。もう一度やり直してください。";
translations["MSG_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "つかうことのできない もじや ぶんしょうが ふくまれています。もういちど やりなおしてください。";
translations["MSG_USER_PROFILE_MESSAGE"] = "ゆうびん";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_TITLE"] = "%{type}の おといあわせ";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "おといあわせ ありがとうございます！\nしたの にゅうりょくわくに おといあわせの ないようを かいてください。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_INPUT_AUTO_REPLY"] =
  translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"];
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] = "がさんかしました。";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_SEND_BTN"] = "おくる";

// Official welcome messages (dynamic index 0..3)
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_0"] =
  "%{name}さん、『まなんでパズル』へ ようこそ！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_1"] =
  "まなんでパズル』では、パズルのように たのしく あそびながら プログラミングを べんきょうできます。\nまずは、じゅんばんに あそびかたや べんきょうのほうほうを おぼえるために、『コースでまなぶ』からはじめて みてください！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_2"] =
  "アルゴリズムやプログラムの やりかたが だいたいわかったところで、『じゆうにつくる』で、じぶんのおもうままに アプリをつくってみてください。";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_3"] =
  "さぁ、『まなんでパズル』を レッツトライ！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING"] = "のひょうかを おくりました。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING_AUTO_REPLY"] =
  "ひょうか ありがとうございました！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_AUTO_REPLY"] =
  "ごいけん ありがとうございました！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TITLE"] = "ごいけん";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TYPE_OTHER"] = "・そのた：";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER"] = "ここにじゆうに かいてください";
translations["MSG_USER_PROFILE_MESSAGE_PUBLISHED_PROJECT_MESSAGE"] =
  "アプリ「%{name}」を公開しました。";

translations["MSG_TOP_TUTORIAL_FIRST_WELCOME_MESSAGE"] =
  "はじめてのひとは\nチュートリアルを\nみてね！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_1"] = "きょうもいっしょに\nがんばろう！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_2"] = "たのしくパズルで\nまなぼうね！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_3"] =
  "ぼくといっしょに\nプログラミングを\nまなぼう！";
translations["MSG_TOP_TUTORIAL_APP_START"] = "はじめる";
translations["MSG_TOP_TUTORIAL_START"] = "チュートリアルをみる";
translations["MSG_TOP_TUTORIAL_DONOT_SHOW"] = "次回から表示しない";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_1"] = "「まなんでパズル」\nについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_2"] = "「コースでまなぶ」\nについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_3"] = "「じゆうにつくる」\nについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_4"] = "ヘルプボタンと\nマイページ";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_5"] = "保護者の方用の\nメニューについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_6"] = "アプリの設定を\n行う";
translations["MSG_TOP_TUTORIAL_CLOSE_PAGE"] = "この画面を閉じる";
translations["MSG_TOP_TUTORIAL_NEXT_PAGE"] = "次へ";
translations["MSG_TOP_TUTORIAL_START_APP"] = "『まなんでパズル』を始める";
translations["MSG_ONBOARDING_FIRST_TIME"] = "はじめて あそぶ";
translations["MSG_ONBOARDING_FIRST_TIME_SUB"] = "アカウント登録なしで体験プランで始められます";
translations["MSG_ONBOARDING_EXISTING_USER"] = "あそんだことがある";
translations["MSG_ONBOARDING_EXISTING_USER_SUB"] = "保護者の方（ログイン・新規登録）はこちら";

// AuthSelection
translations["MSG_AUTH_SELECTION_INSTRUCTION"] =
  "アカウントをお持ちの方は「ログイン」、初めての方は「新規登録」を選んでください。";
translations["MSG_AUTH_SIGN_IN"] = "ログイン";
translations["MSG_AUTH_SIGN_IN_DESC"] = "既存のアカウントでログイン";
translations["MSG_AUTH_SIGN_UP"] = "新規登録";
translations["MSG_AUTH_SIGN_UP_DESC"] = "新しいアカウントを作成";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "おしらせ";

translations["MSG_BACK_BTN"] = "もどる";
translations["MSG_HOME_BTN"] = "ほーむ";
translations["MSG_CLOSE_BTN"] = "とじる";
translations["MSG_CANCEL_BTN"] = "キャンセル";
translations["MSG_NEXT_BTN"] = "つぎへ";
translations["MSG_GENERATE_BTN"] = "つくる";
translations["MSG_CONFIRM_BTN"] = "けってい";
translations["MSG_SAVE_BTN"] = "ほぞん";
translations["MSG_STOP_BTN"] = "やめる";
translations["MSG_DELETE_BTN"] = "さくじょする";
translations["MSG_PARENTS_CANCEL_BTN"] = "キャンセル";
translations["MSG_PARENTS_CONFIRM_BTN"] = "決定";
translations["MSG_PARENTS_DELETE_BTN"] = "削除";
translations["MSG_ERROR_RELOAD_BTN"] = "やりなおす";
translations["MSG_ERROR_TITLE"] = "ただしく しょりを かんりょうすることが できませんでした。";
translations["MSG_ERROR_MESSAGE"] =
  "もういちど やりなおしてください。\nやりなおしても このがめんが でるばあいは、ほごしゃのひとに そうだんしてください。";
translations["MSG_TOAST_FAILED"] = "しっぱいしました";
translations["MSG_TOAST_SEND_FAILED"] = "そうしんしっぱいしました";
translations["MSG_TOAST_EDIT_SUCCESS"] = "へんこうしました";
translations["MSG_TOAST_DELETED_SUCCESS"] = "さくじょしました";
translations["MSG_TOAST_PUBLISHED_SUCCESS"] = "こうかいしました";
translations["MSG_TOAST_DISABLE_PUBLISHED_SUCCESS"] = "こうかいをやめました";
translations["MSG_TOAST_ENABLE_COPIED_SUCCESS"] = "コピーをきょかしました";
translations["MSG_TOAST_DISABLE_COPIED_SUCCESS"] = "コピーをきょかしないにしました";
translations["MSG_TOAST_RESTORE_SUCCESS"] = "アプリをもどしました";
translations["MSG_TOAST_COPY"] = "コピーしました。";
translations["MSG_TOAST_PAST"] = "ペーストしました。";
translations["MSG_TOAST_UNDO"] = "もとに もどしました。";
translations["MSG_TOAST_REDO"] = "やりなおしました。";
translations["MSG_TOAST_INSERT_ASSET_IMAGE_SUCCESS"] = "がぞうを ついかしました。";
translations["MSG_TOAST_INSERT_ASSET_TEMPLATE_SUCCESS"] = "テンプレートを ついかしました。";
translations["MSG_TOAST_CONTACT_SEND"] = "おといあわせを おくりました";
translations["MSG_SETTING_TOP_TUTORIAL"] = "アプリのきどうがめん";
translations["MSG_SETTING_TOP_TUTORIAL_SHOW"] = "さいしょにひょうじ";
translations["MSG_SETTING_TOP_TUTORIAL_NOT_SHOW"] = "ひょうじしない";
translations["MSG_SETTING_APP_LANGUAGE"] = "アプリのひょうじげんご";
translations["MSG_SETTING_SOUND"] = "こうかおん";
translations["MSG_SETTING_BGM"] = "おんがく";
translations["MSG_SETTING_PARENT_GATE"] = "保護者の方用";
translations["MSG_SETTING_GO_TO_TOP"] = "トップページへもどる";
translations["MSG_SETTING_GO_TO_CONTACT"] = "おといあわせ";
translations["MSG_SETTING_GO_TO_REVIEW"] = "アプリのひょうか";
translations["MSG_SETTING_GO_TO_ASSISTANT"] = "まなパルくんと おはなし";
translations["MSG_ASSISTANT_NAME"] = "まなパルくん";
translations["MSG_ASSISTANT_STATUS"] = "おはなし できるよ！";
translations["MSG_ASSISTANT_YOU"] = "あなた";
translations["MSG_ASSISTANT_PLACEHOLDER"] = "メッセージを いれてね...";
translations["MSG_ASSISTANT_SEND"] = "おくる";
translations["MSG_ASSISTANT_STOP"] = "とめる";
translations["MSG_ASSISTANT_GREETING"] =
  "%{name}くん、こんにちは！\nまなパルくんだよ。\nなにか しつもん ある？";
translations["MSG_ASSISTANT_USAGE_COUNT"] = "きょう %{remaining}/%{limit}かい";
translations["MSG_ASSISTANT_EDUCATION_UNAVAILABLE"] =
  "きょうしつプランでは まなパルくんと おはなし できないよ";
translations["MSG_ASSISTANT_PARENT_NOT_ALLOWED"] = "おうちの ひとが きょか していないよ";
translations["MSG_ASSISTANT_SELECT_IMAGE"] = "しゃしんを えらぶ";
translations["MSG_ASSISTANT_TAB_ALBUM"] = "アルバム";
translations["MSG_ASSISTANT_TAB_DRAWING"] = "おえかき";
translations["MSG_ASSISTANT_STAMP_TAB"] = "スタンプ";
translations["MSG_ASSISTANT_TAB_AI"] = "AIがつくったえ";
translations["MSG_ASSISTANT_LIMIT_REACHED"] = "きょうの おはなしは おしまい！また あしたね！";
translations["MSG_SETTING_CLOSE_BTN"] = "このがめんをとじる";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "コースの解答を見る";
translations["MSG_SETTING_TITLE_CORPORATE_AUTH"] = "企業連携認証";
translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "『まなんでパズル』のサイトへ";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "ご利用規約";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "プライバシーポリシー";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "お問い合わせ";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "プレイを再開します";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] =
  "このプレイヤーのプレイを再開します。";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "プレイを中止します";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] =
  "このプレイヤーのプレイを中止します。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] = "有効化できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "有効化できるプレイヤーの数は最大４人までです。\nこのプレイヤーを有効化する場合には、ほかの不要なプレイヤーを無効化（もしくは削除）を行なってください。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] = "変更できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "最低でも１名のプレイヤーが必要です。\nこれ以上プレイヤーを減らすことはできません。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_TITLE"] = "変更できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_MESSAGE"] =
  "ログイン中のプレイヤーは停止できません。\n別のプレイヤーに切り替えてから、このプレイヤーを停止してください。";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "ログアウトします";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "アカウントをログアウトすると、今お使いのプレイヤーで遊ぶことができなくなります。\nプレイヤーの情報はアカウントに保存されますので、また同じプレイヤーで遊びたい場合は、このアカウントで再度ログインを行ってください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] = "【重要】ご注意ください";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "『まなんでパズル』からアカウント削除すると、下記のデータの全てが削除されます。\n・登録したプロフィール情報やアカウント情報。\n・登録した全員分のプレイヤー情報。\n・プレイヤーが作成した「じゆうにつくる」のアプリ。\n・プレイヤーがクリアした「コースでまなぶ」の全ての成績やクリア実績。\n・プレイヤーが行ってきた「トーク履歴」等。\n※ 【重要】ログインしているアカウントの削除を行うと、本アカウントに関連するすべてのデータ削除されますので、十分にご注意ください。\n※ 【重要】この作業はいかなる場合も復旧することはできません。アカウントを削除する場合は十分にご注意ください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] =
  "アカウント削除の理由を教えてください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] = "本当にアカウント削除しますか？";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "アカウント削除するとアカウント・プレイヤーを含むすべてのデータが削除されます。\nアカウント削除処理は復旧することができません。ご注意ください。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"] =
  "連携ができません";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"] =
  "ソーシャルアカウントはすでに別のアカウントと連携しました。";
translations["MSG_SETTING_PARENTS_USER_KIDS_PROFILE_CREATED_AT"] = "登録日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_LATEST_AT"] = "最後ログイン日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "アカウント削除";
translations["MSG_SETTING_PARENTS_USER_PROFILE_DISPLAY_NAME_LIMIT"] =
  "%{limit}文字以内で入力してください。";

translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "コースを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "ステージを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "レベルを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "ステージ";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "レベル";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "認証コード";

translations["MSG_CONTACT_TITLE"] = "おといあわせ";
translations["MSG_CONTACT_TYPE_TITLE"] = "おといあわせの しゅるいを えらんでね";
translations["MSG_CONTACT_DETAIL_TITLE"] = "おといあわせの ないようを くわしく かいてね";
translations["MSG_CONTACT_TYPE_HOW_TO"] = "つかいかたが\nわからない";
translations["MSG_CONTACT_TYPE_BUG"] = "うまく\nうごかない";
translations["MSG_CONTACT_TYPE_REQUEST"] = "ついかして\nほしいきのう";
translations["MSG_CONTACT_TYPE_OTHER"] = "そのたの\nしつもん";
translations["MSG_CONTACT_SEND_BTN"] = "おといあわせを おくる";

translations["MSG_PARENT_GATE_WARNING"] =
  "このページは\nおとなのひとに\nかくにんして\nもらってくださいね";
translations["MSG_PARENT_GATE_TITLE"] = "保護者の方へ";
translations["MSG_PARENT_GATE_DESCRIPTION"] =
  "この先は、保護者の方向けの設定、アカウント情報ページとなります。\n以下の画像を指示のとおりタップしてから、進むボタンを押してください。";
translations["MSG_PARENT_GATE_CLOSE_BTN"] = translations["MSG_SETTING_CLOSE_BTN"];
translations["MSG_PARENT_GATE_CONFIRM_BTN"] = "進む";
translations["MSG_PARENT_GATE_QUESTION_TITLE"] = "画像をこの順番でタップしてください:";
translations["MSG_PARENT_GATE_SHAPE_RECT"] = "四角";
translations["MSG_PARENT_GATE_SHAPE_STAR"] = "星型";
translations["MSG_PARENT_GATE_SHAPE_CIRCLE"] = "円形";
translations["MSG_PARENT_GATE_SHAPE_TRIANGLE"] = "三角";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "保護者";

translations["MSG_COURSE_COMING_SOON_WARNING_MESSAGE"] =
  "このカセットは まだあそべないよ。\nもうちょっとまってね！";
translations["MSG_COURSE_START_BTN"] = "スタート";
translations["MSG_COURSE_GOTO_MAP_BTN"] = "ステージへ";
translations["MSG_COURSE_STAGE_CLEAR_TITLE"] = "ここまでクリア！";
translations["MSG_COURSE_LEVEL_OVERVIEW_SUMMARY"] = "このレベルでまなぶこと";
translations["MSG_COURSE_LEVEL_OVERVIEW_START_BTN"] = "はじめる";
translations["MSG_COURSE_GAME_TIPS_NEXT_BTN"] = "つぎへ";
translations["MSG_COURSE_GAME_TIPS_BACK_BTN"] = "まえにもどる";
translations["MSG_COURSE_GAME_TIPS_ACTION_BTN"] = "やってみる";
translations["MSG_COURSE_GAME_HINT_BTN"] = "ヒント";
translations["MSG_COURSE_GAME_CLEAR"] = "クリア";
translations["MSG_COURSE_GAME_SCORE_TEXT"] = "てにいれたアイテム";
translations["MSG_COURSE_GAME_SCORE_STATUS"] = "こ/%{total}こ";
translations["MSG_COURSE_GAME_START_BTN"] = "スタート！";
translations["MSG_COURSE_GAME_RESET_BTN"] = "やりなおす";
translations["MSG_COURSE_GAME_SUCCESS_TEXT"] = "おめでとう!このレベルをクリアしたよ!";
translations["MSG_COURSE_GAME_SUCCESS_REVIEW_BTN"] = "みなおす";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_LEVEL_BTN"] = "つぎのレベルにすすむ";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_STAGE_BTN"] = "つぎのステージにすすむ";
translations["MSG_COURSE_GAME_FAILED_TITLE"] = "ざんねん！";
translations["MSG_COURSE_GAME_FAILED_TEXT"] =
  "もういっかい やってみましょう！\n\nむずかしくて わからないときは、\nヒントを さんこうにしてください。";
translations["MSG_COURSE_GAME_FAILED_RESET_BTN"] = "もういっかいやる";
translations["MSG_COURSE_GAME_STAGE_CLEAR"] = "おめでとう!ステージをクリアしたよ!";
translations["MSG_COURSE_ALL_GAME_STAGE_CLEAR"] =
  "おめでとう！\nいま ちょうせんできる\nすべての ステージを クリアしたよ！\nあたらしい ステージが ついか されるまで\nたのしみに まっていてね！";
translations["MSG_COURSE_PROGRAM_RUN"] = "スタート";
translations["MSG_COURSE_ALGORITHM"] = "アルゴリズムをまなぼ！";
translations["MSG_COURSE_PROGRAM"] = "はじめてのプログラミング";
translations["MSG_COURSE_ALGORITHM_ADVANCED"] = "アルゴリズム上級";
translations["MSG_COURSE_GROUP_WORK"] = "グループワーク";
translations["MSG_COURSE_COORDINATE_X"] = "よこのいち（Xざひょう）";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_NEXT_BTN"] = "つぎへ";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_LATER_BTN"] = "あとでみる";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CONTINUE_BTN"] = "ガイドをつづける";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_ACTION_BTN"] = "やってみる";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CLOSE_BTN"] = "ガイドをおわる";
translations["MSG_CREATOR_CREATE_APP"] = "あたらしくつくる";
translations["MSG_CREATOR_CREATE_APP_TITLE"] = "アプリをつくる";
translations["MSG_CREATOR_CREATE_APP_NAME"] = "アプリになまえをつけてください。";
translations["MSG_CREATOR_CREATE_APP_NAME_PREFIX"] = "アプリ";
translations["MSG_CREATOR_APP_DETAIL_BTN"] = "くわしく";
translations["MSG_CREATOR_RUN_APP_BTN"] = "うごかす";
translations["MSG_CREATOR_APP_MY_APPS"] = "マイアプリ";
translations["MSG_CREATOR_APP_SHARED_APPS"] = "みんなのアプリ";
translations["MSG_CREATOR_APP_SHARED_APPS_EMPTY_MESSAGE"] =
  "このじょうけんのアプリがありませんでした。\nじょうけんをかえて、もういちど けんさくしてください。";
translations["MSG_CREATOR_APP_DELETED_APPS"] = "ゴミばこ";
translations["MSG_CREATOR_APP_DELETED_APPS_MESSAGE"] =
  "「マイアプリ」に もどしたい アプリを\nえらんで ください。\n（さいきん さくじょした アプリが\n5つまで のこっています）";
translations["MSG_CREATOR_APP_SETTING_TITLE"] = "アプリのせってい";
translations["MSG_CREATOR_APP_SETTING_APP_NAME"] = "アプリのなまえ";
translations["MSG_CREATOR_APP_SETTING_APP_TAG"] = "タグ";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_TITLE"] = "みんなのアプリにのせる";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_OFF"] = "ひこうかい";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_ON"] = "こうかい";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_TITLE"] = "ほかのひとがコピーできる";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_OFF"] = "コピーを\nきんしする";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_ON"] = "コピーを\nきょかする";
translations["MSG_CREATOR_APP_SETTING_APP_CHANGE_COVER_PAGE_BTN"] = "ひょうしをへんこう";
translations["MSG_CREATOR_APP_DETAIL_APP_AUTHOR"] = "はじめにつくったひと";
translations["MSG_CREATOR_APP_DETAIL_APP_EDITOR"] = "つくりかえたひと";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "なまえをいれてください";
translations["MSG_CREATOR_APP_SELECT_PLACEHOLDER"] = "select app";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_TITLE"] = "アプリのせつめい";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_NONE"] = "せつめいが ありません";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_PLACEHOLDER"] =
  "アプリの せつめいを にゅうりょく してください";
translations["MSG_CREATOR_APP_DETAIL_TITLE_APP_CODE"] = "アプリ\nコード";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP"] = "みんなの\nアプリ";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_PUBLISHED"] = "こうかいちゅう";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_NOT_PUBLISHED"] = "ひこうかい";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS"] = "ほかの\nひと";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_ENABLE"] = "コピーできる";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_DISABLE"] = "コピーできない";
translations["MSG_CREATOR_APP_DETAIL_APP_DELETED_AT"] = "さくじょ\nした日";
translations["MSG_CREATOR_APP_EDITOR_BTN"] = "つくる";
translations["MSG_CREATOR_APP_COMPLETELY_BTN"] = "かんぜんにけす";
translations["MSG_CREATOR_APP_RESTORE_BTN"] = "もとにもどす";
translations["MSG_CREATOR_APP_DELETE_WARNING_TITLE"] = "アプリをさくじょしますか？";
translations["MSG_CREATOR_APP_DELETE_WARNING_MESSAGE"] =
  "「%{name}」を さくじょします。\nアプリをへんしゅうできなくなります。\nアプリをつかうことはできません。";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "がぞうを さくじょしますか？";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  "「%{name}」を さくじょします。\nがぞうをさくじょすると もとに もどせなくなります。";
translations["MSG_CREATOR_CREATE_APP_PICKUP_NAME"] = "ピックアップ";
translations["MSG_CREATOR_CREATE_APP_PICKUP_MONTH_TITLE"] = "%{month}がつの";
translations["MSG_CREATOR_CREATE_APP_PICKUP_SUBTITLE"] = "きになるアプリをごしょうかい！";
translations["MSG_CREATOR_APP_PUBLISH_TITLE"] = "「みんなのアプリ」に こうかい しますか？";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_TITLE"] = "アプリの こうかいが できません";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_MESSAGE"] =
  "アプリの のこうかいが きょかされていません。\nほごしゃメニューから きょかをしてください。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_TITLE"] =
  "「みんなのアプリ」への こうかいを やめますか？";
translations["MSG_CREATOR_APP_PUBLISH_WARNING"] =
  "「%{name}」を「みんなのアプリ」に こうかいします。\nアプリを こうかい すると、ほかの ひとが この アプリを つかうことが できるように なります。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_WARNING"] =
  "「%{name}」を「みんなのアプリ」に こうかいしない ようにします。\nこうかいを やめると、ほかのひとが このアプリを つかえなく なります。";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_ENABLE"] = "コピーを きょかして こうかい";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_DISABLE"] = "コピーを きょかしないで こうかい";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_NOTICE"] =
  "※アプリは あとで こうかいを やめることも できます。";
translations["MSG_CREATOR_PUBLISH_CONFIRM_BTN"] = "こうかいする";
translations["MSG_CREATOR_DISABLE_PUBLISH_CONFIRM_BTN"] = "ひこうかいにする";
translations["MSG_CREATOR_APP_ENABLE_COPIED_TITLE"] = "このアプリのコピーのせってい";
translations["MSG_CREATOR_APP_DISABLE_COPIED_TITLE"] = "このアプリのコピーのせってい";
translations["MSG_CREATOR_APP_ENABLE_COPIED_MESSAGE"] =
  "ほかのひとが「%{name}」をコピーできるように、コピーをきょかします。";
translations["MSG_CREATOR_APP_DISABLE_COPIED_MESSAGE"] =
  "ほかのひとが「%{name}」をコピーできないように、コピーきんしにします。";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_TITLE"] = "このがぞうは りようできません";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_MESSAGE"] =
  "アプリについかできるがぞうは さいしんの%{limit}こ だけです。\nそれいがいの がぞうも りよう できるように なりましたら、おしらせします。";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_TITLE"] = "アプリを さくじょできません";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_MESSAGE"] =
  "みんなのアプリにこうかいちゅうのアプリは さくじょ できません。\nこのアプリをさくじょしたいときは、さきに ひこうかいに してください。";
// プラン別プロジェクト制限メッセージ
// 体験ユーザー向け（アカウント作成促進）
// プラン別チュートリアル制限メッセージ
// 体験ユーザー向け
// 無料ユーザー向け
// 基本プランユーザー向け
translations["MSG_CREATOR_APP_SORT_FILTER_TITLE"] = "みつける";
translations["MSG_CREATOR_APP_KEYWORD_SEARCH_TITLE"] = "ことばでみつける";
translations["MSG_CREATOR_APP_SORT_TITLE"] = "ならべかえ";
translations["MSG_CREATOR_APP_SORT_FAVORITED"] = "にんき";
translations["MSG_CREATOR_APP_SORT_VIEWED"] = "にんき";
translations["MSG_CREATOR_APP_SORT_DATE"] = "じかん";
translations["MSG_CREATOR_APP_FILTER_TITLE"] = "しぼりこみ";
translations["MSG_CREATOR_APP_FILTER_OFFICIAL"] = "こうしき";
translations["MSG_CREATOR_APP_FILTER_FAVORITED"] = "いいね";
translations["MSG_CREATOR_APP_DISABLE_BTN"] = "できません";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_TITLE"] = "アプリをかんぜんにけしますか？";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_SUBTITLE"] =
  "「%{name}」を かんぜんに けします。\nかんぜんにけすと、アプリを もとにもどすことはできなくなります。";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_TITLE"] = "「マイアプリ」に もどしますか？";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_SUBTITLE"] =
  "「%{name}」を「マイアプリ」に もどしますか？";
translations["MSG_CREATOR_SCREEN_LIST_HEADER"] = "ページ";
translations["MSG_CREATOR_COMPONENT_LIST_HEADER"] = "せんたくちゅう";
translations["MSG_CREATOR_MENU_CONTEXT_DELETE"] = "さくじょ";
translations["MSG_CREATOR_MENU_CONTEXT_COPY"] = "コピー";
translations["MSG_CREATOR_MENU_CASSETTE_ACTION"] = "カセットそうさ";
translations["MSG_CREATOR_MENU_RUN_APP_BTN"] = "アプリを\nうごかす";
translations["MSG_CREATOR_MENU_SET_APP_BTN"] = "アプリの\nせってい";
translations["MSG_CREATOR_MENU_PUBLISH_APP_BTN"] = "アプリを\nこうかい";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_APP_BTN"] = "アプリを\nひこうかい";
translations["MSG_CREATOR_MENU_PUBLISH_TEMPLATE_BTN"] = "テンプレートを\nこうかい";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_TEMPLATE_BTN"] = "テンプレートを\nひこうかい";
translations["MSG_CREATOR_MENU_CLOSE_BTN"] = "このがめんを\nとじる";
translations["MSG_CREATOR_MENU_COMPONENT_BTN"] = "パーツ";
translations["MSG_CREATOR_MENU_COMPONENT_ACTION_BTN"] = "おしごと";
translations["MSG_CREATOR_MENU_COMPONENT_SHAPE_BTN"] = "ずけい";
translations["MSG_CREATOR_MENU_COMPONENT_STAMP_BTN"] = "スタンプ";
translations["MSG_CREATOR_MENU_COMPONENT_STOCK_BTN"] = "どうぐばこ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_ACTION"] = "そうさパーツ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_SHAPE"] = "ずけいパーツ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP"] = "スタンプパーツ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_CHARACTER"] = "キャラクター";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GAME"] = "あそび";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ANIMAL"] = "いきもの";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_EVENT"] = "イベント";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_INTERNET"] = "インターネット";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_MONEY"] = "おかね";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GOODS"] = "ざっか";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_NATURE"] = "しぜん";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_PERSON"] = "じんぶつ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_BUILDING"] = "たてもの";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_FOOD"] = "たべもの";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ELECTRONIC"] = "でんき";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_SMILE"] = "にこちゃん";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_VEHICLE"] = "のりもの";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_STATIONARY"] = "ぶんぼうぐ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_OTHERS"] = "そのほか";
translations["MSG_CREATOR_MENU_DRAWING_BTN"] = "おえかき";
translations["MSG_CREATOR_MENU_DRAWING_PEN"] = "ペン";
translations["MSG_CREATOR_MENU_DRAWING_ERASER"] = "けしごむ";
translations["MSG_CREATOR_MENU_DRAWING_SIZE"] = "ふとさ";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_LIGHT"] = "ほそい";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_NORMAL"] = "ふつう";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_BOLD"] = "ふとい";
translations["MSG_CREATOR_MENU_DRAWING_COLOR"] = "いろ";
translations["MSG_CREATOR_MENU_DRAWING_RESET"] = "やりなおす";
translations["MSG_CREATOR_MENU_DRAWING_FINISH"] = "かんせい";
translations["MSG_CREATOR_MENU_STOCK_PARTS_USE_BTN"] = "ついか";
translations["MSG_CREATOR_MENU_COMPONENT_PREVIEW_TITLE"] = "%{name}のパーツいちらん";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "アルバム";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] = "スケッチブック";
translations["MSG_CREATOR_MENU_PROPERTY_BTN"] = "デザイン";
translations["MSG_CREATOR_MENU_PROPERTY_BASIC"] = "きほん";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION"] = "ばしょ";
translations["MSG_CREATOR_MENU_PROPERTY_SIZE"] = "サイズ";
translations["MSG_CREATOR_MENU_PROPERTY_APPEARANCE"] = "みため";
translations["MSG_CREATOR_MENU_PROPERTY_COLOR"] = "いろ";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC"] = "プログラム";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC_TITLE"] = "%{name}のプログラム";

translations["MSG_CREATOR_MENU_PROPERTY_NAME"] = "なまえ";
translations["MSG_CREATOR_MENU_PROPERTY_NAME_PLACEHOLDER"] = "なまえをつけてください";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE_TITLE"] = "トップページ";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE"] = "このページからはじめる";
translations["MSG_CREATOR_MENU_PROPERTY_FONT_FAMILY"] = "フォントのしゅるい";
translations["MSG_CREATOR_TEXT_WEIGHT_BOLD"] = "ふとい";
translations["MSG_CREATOR_TEXT_WEIGHT_REGULAR"] = "ふつう";
translations["MSG_CREATOR_TEXT_WEIGHT_LIGHT"] = "ほそい";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT"] = "ひょうじするないよう";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX"] = "かさなり";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_FRONT"] = "いちばんうえへ";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_BACK"] = "いちばんしたへ";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION_X_Y"] = "よことたてのばしょ";
translations["MSG_CREATOR_MENU_PROPERTY_X"] = "よこのばしょ";
translations["MSG_CREATOR_MENU_PROPERTY_Y"] = "たてのばしょ";
translations["MSG_CREATOR_MENU_PROPERTY_X_COORDINATE"] = "よこ";
translations["MSG_CREATOR_MENU_PROPERTY_Y_COORDINATE"] = "たて";
translations["MSG_CREATOR_MENU_PROPERTY_WIDTH"] = "よこはば";
translations["MSG_CREATOR_MENU_PROPERTY_HEIGHT"] = "たかさ";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER"] = "わく";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW"] = "かげ";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SIZE"] = "テキスト";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW"] = "テキストのかげ";
translations["MSG_CREATOR_MENU_PROPERTY_OPACITY"] = "みえやすさ";
translations["MSG_CREATOR_MENU_PROPERTY_ROTATION"] = "かくど";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_RADIUS"] = "かどのまるさ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO"] = "がぞうのじょうほう";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_NAME"] = "なまえ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_SIZE"] = "おおきさ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_FILE_SIZE"] = "ファイルサイズ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_BTN"] = "がぞうをえらぶ";
translations["MSG_CREATOR_MENU_PROPERTY_BACKGROUND_COLOR"] = "ぬりつぶし";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_COLOR"] = "わく";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW_COLOR"] = "かげ";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_COLOR"] = "テキスト";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW_COLOR"] = "テキストのかげ";

translations["MSG_CREATOR_MENU_BLOCKLY_TITLE"] = "ブロック";
translations["MSG_CREATOR_MENU_BLOCKLY_EVENT"] = "イベント";
translations["MSG_CREATOR_MENU_BLOCKLY_ANIMATION"] = "うごき";
translations["MSG_CREATOR_MENU_BLOCKLY_LOGIC"] = "ロジック";
translations["MSG_CREATOR_MENU_BLOCKLY_CONTROL"] = "せいぎょ";
translations["MSG_CREATOR_MENU_BLOCKLY_MATH"] = "えんざん";
translations["MSG_CREATOR_MENU_BLOCKLY_VARIABLE"] = "へんすう";
translations["MSG_CREATOR_MENU_BLOCKLY_PROCEDURE"] = "かんすう";
translations["MSG_CREATOR_MENU_BLOCKLY_PROMPT_INPUT_MESSAGE"] = "%{placeholder}のあたい";

translations["MSG_CREATOR_COMPONENT_NAME_SCREEN"] = "ページ";
translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"] = "ボタン";
translations["MSG_CREATOR_COMPONENT_NAME_LABEL"] = "ラベル";
translations["MSG_CREATOR_COMPONENT_NAME_FORM"] = "フォーム";
translations["MSG_CREATOR_COMPONENT_NAME_CHECKBOX"] = "チェックボックス";
translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"] = "スイッチ";
translations["MSG_CREATOR_COMPONENT_NAME_IMAGE"] = "がぞう";
translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"] = "えん";
translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"] = "さんかく";
translations["MSG_CREATOR_COMPONENT_NAME_RECT"] = "しかく";
translations["MSG_CREATOR_COMPONENT_NAME_STAR"] = "ほし";
translations["MSG_CREATOR_COMPONENT_NAME_LINE"] = "せん";
translations["MSG_CREATOR_COMPONENT_NAME_STAMP"] = "スタンプ";
translations["MSG_CREATOR_COMPONENT_NAME_DRAWING"] = "おえかき";
translations["MSG_CREATOR_COMPONENT_LABEL_BUTTON"] =
  translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"];
translations["MSG_CREATOR_COMPONENT_LABEL_LABEL"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LABEL"];
translations["MSG_CREATOR_COMPONENT_LABEL_FORM"] = translations["MSG_CREATOR_COMPONENT_NAME_FORM"];
translations["MSG_CREATOR_COMPONENT_LABEL_CHECKBOX"] = "チェック\nボックス";
translations["MSG_CREATOR_COMPONENT_LABEL_SWITCH"] =
  translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"];
translations["MSG_CREATOR_COMPONENT_LABEL_IMAGE"] = "がぞう\nボックス";
translations["MSG_CREATOR_COMPONENT_LABEL_CIRCLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_TRIANGLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_RECT"] = translations["MSG_CREATOR_COMPONENT_NAME_RECT"];
translations["MSG_CREATOR_COMPONENT_LABEL_STAR"] = translations["MSG_CREATOR_COMPONENT_NAME_STAR"];
translations["MSG_CREATOR_COMPONENT_LABEL_LINE"] = translations["MSG_CREATOR_COMPONENT_NAME_LINE"];

translations["MSG_BLOCKLY_VARIABLES"] = "へんすう";
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "すうじを つかって ください。";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "%{limit}もじ までに してください。";
translations["MSG_ASSET_ALBUM_TITLE"] = "アルバムの なかみ";
translations["MSG_ASSET_DRAWING_TITLE"] = "スケッチブックの なかみ";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "がぞうついか";
translations["MSG_ASSET_DRAWING_ADD_ALBUM_TITLE"] =
  "『まなんでパズル』でついかした、がぞうや しゃしんが ここについかされます。";
translations["MSG_ASSET_DRAWING_ADD_WARNING_TITLE"] =
  "『じゆうにつくる』の「おえかき」メニューでえをかくと、ここに ついかされます。";
translations["MSG_ASSET_ADD_TO_SCREEN_BTN"] = "アプリに\nついか";
translations["MSG_CREATOR_MENU_MATERIAL_TAB_ASSET_SELECT"] = "チャットに\nついかする";
translations["MSG_ASSET_DELETE_BTN"] = "がぞうを\nさくじょ";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] = "まだ がぞうの データがありません。";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] = "まだ おえかき のデータがありません。";
translations["MSG_ASSET_STORAGE_OVER_LIMIT"] = "ストレージが いっぱいです";
translations["MSG_REACTION_TAG_TITLE"] = "きもちスタンプ";
translations["MSG_REACTION_USERS"] = "みんなの\nきもち";
translations["MSG_REACTION_DIFFICULT"] = "てごわい！";
translations["MSG_REACTION_EASY"] = "かんたん";
translations["MSG_REACTION_COOL"] = "いいね！";
translations["MSG_REACTION_FUN"] = "たのしい";
translations["MSG_REACTION_AMAZING"] = "すごい";
translations["MSG_REACTION_BAD"] = "う〜ん？";

// User Plan
translations["MSG_CURRENT_PLAN"] = "げんざいのプラン";
translations["MSG_PLAN_TRIAL"] = "たいけん";
translations["MSG_PLAN_SAKIDORI"] = "さきどり";
translations["MSG_PLAN_FREE"] = "むりょう";
translations["MSG_PLAN_STANDARD"] = "きほん";
translations["MSG_PLAN_PREMIUM"] = "とくべつ";
translations["MSG_PLAN_BUILDER"] = "ビルダー";
translations["MSG_PLAN_EDUCATION"] = "きょうしつ";
translations["MSG_PLAN_UNKNOWN"] = "ふめい";
// Plan names for parent pages (kanji)
translations["MSG_PLAN_TRIAL_PARENT"] = "体験";
translations["MSG_PLAN_FREE_PARENT"] = "無料";
translations["MSG_PLAN_STANDARD_PARENT"] = "基本";
translations["MSG_PLAN_PREMIUM_PARENT"] = "特別";
translations["MSG_PLAN_BUILDER_PARENT"] = "ビルダー";
translations["MSG_PLAN_EDUCATION_PARENT"] = "教室";
translations["MSG_PLAN_UNKNOWN_PARENT"] = "不明";
translations["MSG_PLAN_FREE_FULL_PARENT"] = "無料プラン";
translations["MSG_PLAN_STANDARD_FULL_PARENT"] = "基本プラン";
translations["MSG_PLAN_PREMIUM_FULL_PARENT"] = "特別プラン";

// Subscription - Common
// Subscription - Purchase Page
translations["MSG_SUBSCRIPTION_MONTHLY_TITLE"] = "月額プラン";
translations["MSG_SUBSCRIPTION_ANNUAL_TITLE"] = "年額プラン";
translations["MSG_SUBSCRIPTION_ANNUAL_BADGE"] = "2ヶ月分お得！";
translations["MSG_SUBSCRIPTION_PURCHASE_BTN"] = "購入する";
translations["MSG_SUBSCRIPTION_UPGRADE_BTN"] = "アップグレード";
translations["MSG_LOGIN_REQUIRED_TITLE"] = "アカウント登録が必要です";
translations["MSG_LOGIN_REQUIRED_MESSAGE"] =
  "有料プランを購入するにはアカウント登録が必要です\nアカウント登録は無料で、メールアドレス・Googleアカウント・Apple IDで簡単に作成できます\n登録後、保護者ページの「課金管理」タブからお好みのプランをお選びいただけます";
translations["MSG_SUBSCRIPTION_PURCHASE_SUCCESS"] = "購入が完了しました！";
translations["MSG_SUBSCRIPTION_PURCHASE_ERROR"] = "購入に失敗しました。もう一度お試しください。";
// Subscription - Plan Comparison
translations["MSG_SUBSCRIPTION_COMPARISON_RECOMMENDED"] = "おすすめ";
// Subscription - Status Page
translations["MSG_SUBSCRIPTION_REACTIVATE_SUCCESS"] = "購読を再開しました";
translations["MSG_SUBSCRIPTION_REACTIVATE_ERROR"] = "購読の再開に失敗しました";
translations["MSG_SUBSCRIPTION_MANAGE"] = "サブスクリプション管理";
translations["MSG_SUBSCRIPTION_PORTAL_ERROR"] = "ポータルを開けませんでした";
translations["MSG_SUBSCRIPTION_STORE_MANAGE_TITLE"] = "サブスクリプション管理";
translations["MSG_SUBSCRIPTION_MANAGE_APP_STORE_MESSAGE"] =
  "サブスクリプションの管理はApp Storeから行えます。\n\n設定 → Apple ID → サブスクリプション から管理できます。";
translations["MSG_SUBSCRIPTION_MANAGE_PLAY_STORE_MESSAGE"] =
  "サブスクリプションの管理はGoogle Playから行えます。\n\nPlayストア → お支払いと定期購入 → 定期購入 から管理できます。";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_TITLE"] = "別のプラットフォームで購入";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_MESSAGE"] =
  "このサブスクリプションは別のプラットフォームで購入されたため、こちらでは管理できません。\n\n購入したプラットフォームからサブスクリプションを管理してください。";

// Subscription - Cancel Page
translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_TITLE"] = "本当に解約しますか？";
translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_MESSAGE"] =
  "解約すると、次回更新日から無料プランに戻ります。\n今までのデータは残ります。";
translations["MSG_SUBSCRIPTION_CANCEL_SUCCESS"] = "解約を受け付けました";
translations["MSG_SUBSCRIPTION_CANCEL_ERROR"] = "解約に失敗しました";
// 返金（クーリングオフ）
// Stripe Elements決済モーダル
// サブスクリプション - アップグレード
translations["MSG_PARENT_PAGE_BILLING_PERIOD"] = "契約期間";
translations["MSG_SUBSCRIPTION_MONTHLY_LABEL"] = "月額";
translations["MSG_SUBSCRIPTION_ANNUAL_LABEL"] = "年額";
// 保護者ページ - タブ
translations["MSG_PARENT_PAGE_TAB_ACCOUNT"] = "アカウント";
translations["MSG_PARENT_PAGE_TAB_PLAYER"] = "プレイヤー";
translations["MSG_PARENT_PAGE_TAB_SUBSCRIPTION"] = "課金管理";
translations["MSG_PARENT_PAGE_TAB_NOTIFICATION"] = "お知らせ";
translations["MSG_PARENT_PAGE_TAB_MESSAGE"] = "メッセージ";
translations["MSG_PARENT_PAGE_TAB_OTHER"] = "その他";

// 保護者ページ - メッセージタブ
translations["MSG_PARENT_PAGE_MESSAGE_INPUT_PLACEHOLDER"] = "メッセージを入力...";
translations["MSG_PARENT_PAGE_MESSAGE_NO_ROOMS"] = "チャットルームがありません";
translations["MSG_PARENT_PAGE_MESSAGE_NO_MESSAGES"] = "メッセージはまだありません";
translations["MSG_PARENT_PAGE_MESSAGE_LOAD_MORE"] = "もっとみる";
translations["MSG_LOADING"] = "読み込み中...";

// 保護者ページ - プラン名
translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "購入方法";
translations["MSG_PARENT_PAGE_EDUCATION_DESCRIPTION"] =
  "教室プランをご利用中です。詳しくは管理者にお問い合わせください。";

// 保護者ページ - アカウントタブ
translations["MSG_PARENT_PAGE_ACCOUNT_INFO"] = "アカウント情報";
translations["MSG_PARENT_PAGE_NICKNAME"] = "ニックネーム";
translations["MSG_PARENT_PAGE_ICON"] = "アイコン";
translations["MSG_PARENT_PAGE_EMAIL"] = "メールアドレス";
translations["MSG_PARENT_PAGE_EMAIL_VERIFIED"] = "メール認証";
translations["MSG_PARENT_PAGE_VERIFIED"] = "認証済み";
translations["MSG_PARENT_PAGE_CREATED_AT"] = "アカウント作成日";
translations["MSG_PARENT_PAGE_CHANGE"] = "変更";
translations["MSG_PARENT_PAGE_SNS_LINK"] = "アカウント連携";
translations["MSG_PARENT_PAGE_GOOGLE_ACCOUNT"] = "Googleアカウント";
translations["MSG_PARENT_PAGE_APPLE_ID"] = "Apple ID";
translations["MSG_PARENT_PAGE_LINK"] = "連携する";
translations["MSG_PARENT_PAGE_UNLINK"] = "連携解除";

// 保護者ページ - プロフィールセクション
translations["MSG_PARENT_PAGE_PROFILE_SECTION_TITLE"] = "プロフィール情報";
translations["MSG_PARENT_PAGE_PROFILE_EDIT_TITLE"] = "プロフィールを編集";
translations["MSG_PARENT_PAGE_PROFILE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_PROFILE_BASIC_INFO"] = "基本情報";
translations["MSG_PARENT_PAGE_PROFILE_REGION_PLACEHOLDER"] = "例: 東京都";
translations["MSG_PARENT_PAGE_PROFILE_CITY_PLACEHOLDER"] = "例: 渋谷区";
translations["MSG_PARENT_PAGE_PROFILE_NOTES"] = "自己紹介";
translations["MSG_PARENT_PAGE_TAB_BASIC"] = "基本情報";
translations["MSG_PARENT_PAGE_TAB_FAVORITES"] = "個性";
translations["MSG_PARENT_PAGE_TAB_APPEARANCE"] = "見た目";
translations["MSG_PARENT_PAGE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_EDIT_FAVORITE_COLOR"] = "好きな色を編集";
translations["MSG_PARENT_PAGE_EDIT_SELF_INTRO"] = "自己紹介を編集";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_SUCCESS"] = "プロフィールを更新しました";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_ERROR"] = "プロフィールの更新に失敗しました";

// 保護者ページ - アイコン変更モーダル
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT"] = "いま";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED"] = "これにする？";
translations["MSG_ICON_CHANGE_CONFIRM_BTN"] = "けってい";
translations["MSG_ICON_CHANGE_AI_CANCEL"] = "キャンセル";
// AI利用制限
translations["MSG_QUOTA_EXCEEDED"] = "きょうはつかいきっちゃったよ！またあしたね！";
translations["MSG_QUOTA_RESET_TIME"] = "あした0:00リセット";
translations["MSG_AI_PROCESSING"] = "AIでつくっているよ...";

// Player向け IconChangeModal キー（ひらがな版）
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT_PARENT"] = "現在";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED_PARENT"] = "選択中";
// 素材AI画像生成（自由入力）- 保護者向け
// AI生成スタイル（Player向けひらがな）
// AI生成オプション（Player向けひらがな）
// AI加工タイプ（Player向けひらがな）
// AI加工スタイルオプション（Player向けひらがな）
// AI加工背景オプション（Player向けひらがな）
// AI加工コスチュームオプション（Player向けひらがな）
// AI加工動物耳オプション（Player向けひらがな）
// AI加工アクセサリーオプション（Player向けひらがな）
// AI加工季節テーマオプション（Player向けひらがな）
translations["MSG_PARENT_PAGE_ACCOUNT_ACTIONS"] = "アカウント操作";
translations["MSG_PARENT_PAGE_CHANGE_PASSWORD"] = "パスワードを変更";
translations["MSG_PARENT_PAGE_LOGOUT"] = "ログアウト";
// 保護者ページ - ニックネーム変更モーダル
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_TITLE"] = "ニックネームを変更";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_MESSAGE"] = "新しいニックネームを入力してください";
translations["MSG_PARENT_PAGE_NICKNAME_ERROR_MESSAGE"] = "他の名前をお試しください";
// 保護者ページ - 子供管理タブ
translations["MSG_PARENT_PAGE_ADD"] = "追加";
translations["MSG_PARENT_PAGE_ACTIVE"] = "アクティブ";
translations["MSG_PARENT_PAGE_INACTIVE"] = "非アクティブ";
translations["MSG_PARENT_PAGE_PLAYABLE"] = "プレイ可能";
translations["MSG_PARENT_PAGE_SUSPENDED"] = "停止中";
translations["MSG_PARENT_PAGE_SWITCH_LOGIN"] = "切り替え";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_TITLE"] = "切り替えできません";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_MESSAGE"] =
  "このプレイヤーは停止中のため、ログインに切り替えることができません。先にプレイヤーを有効化してください。";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_TITLE"] = "プレイヤーを切り替えますか？";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_MESSAGE"] = "「%{name}」に切り替えます。";
translations["MSG_PARENT_PAGE_BASIC_INFO"] = "基本情報";
translations["MSG_PARENT_PAGE_AGE"] = "年齢";
translations["MSG_PARENT_PAGE_YEARS_OLD"] = "歳";
translations["MSG_PARENT_PAGE_GENDER"] = "性別";
translations["MSG_PARENT_PAGE_BIRTHDAY"] = "誕生日";
translations["MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE"] = "アカウント追加日";
translations["MSG_GENDER_SELECT_TITLE"] = "どちらかを えらんでね";
translations["MSG_GENDER_STATUS_LABEL"] = "せいべつ";
translations["MSG_GENDER_NOT_SELECTED"] = "みせんたく";
translations["MSG_GENDER_MALE"] = "おとこのこ";
translations["MSG_GENDER_FEMALE"] = "おんなのこ";
translations["MSG_GENDER_NONE"] = "なし";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_TITLE"] = "名前変更";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_MESSAGE"] = "新しい名前を入力してください";
translations["MSG_PARENT_PAGE_YEAR"] = "年";
translations["MSG_PARENT_PAGE_MONTH"] = "月";
translations["MSG_PARENT_PAGE_DAY"] = "日";
translations["MSG_PARENT_PAGE_GENDER_EDIT_TITLE"] = "性別変更";
translations["MSG_PARENT_PAGE_GENDER_EDIT_MESSAGE"] = "性別を選択してください";
translations["MSG_PARENT_PAGE_BIRTHDAY_EDIT_TITLE"] = "誕生日変更";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_TITLE"] = "表示言語変更";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_MESSAGE"] = "表示言語を選択してください";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE"] = "プレイヤーを追加できません";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE"] =
  "現在のプランでは最大{{limit}}人までプレイヤーを追加できます。\nプランをアップグレードすると、より多くのプレイヤーを追加できます。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_TITLE"] = "プレイヤーを削除しますか？";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MESSAGE"] =
  "{{name}}を削除すると、このプレイヤーの全てのデータ（進捗、作品など）が失われます。\nこの操作は取り消せません。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_TITLE"] = "プレイヤーを削除できません";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_MESSAGE"] =
  "最低1人のプレイヤーが必要です。\n削除する前に別のプレイヤーを追加してください。";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "危険な操作";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "プレイヤーを削除";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] = "このプレイヤーの全てのデータが削除されます";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "削除";
translations["MSG_PARENT_PAGE_COURSE_CLEAR"] = "コースクリア";
translations["MSG_PARENT_PAGE_CREATED_PROJECTS"] = "つくった作品";
translations["MSG_PARENT_PAGE_PUBLISHED_PROJECTS"] = "公開した作品";
translations["MSG_PARENT_PAGE_RECEIVED_LIKES"] = "もらったいいね";
translations["MSG_PARENT_PAGE_SETTINGS"] = "設定";
translations["MSG_PARENT_PAGE_DISPLAY_LANGUAGE"] = "ひょうじげんご";
translations["MSG_PARENT_PAGE_HIRAGANA"] = "ひらがな";
translations["MSG_PARENT_PAGE_KANJI"] = "漢字";
translations["MSG_PARENT_PAGE_PROJECT_PUBLISH"] = "作品の公開";
translations["MSG_PARENT_PAGE_COPY_PERMISSION"] = "コピー許可";
translations["MSG_PARENT_PAGE_AI_CHAT"] = "まなパルくんとのおはなし";
translations["MSG_PARENT_PAGE_AI_GENERATION"] = "AIで素材作成";
translations["MSG_PARENT_PAGE_ACCOUNT_STATUS"] = "アカウント状態";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "危険な操作";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] =
  "すべての学習データ・作品が削除されます。この操作は取り消せません。";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "このプレイヤーを削除";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "削除する";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY"] = "最近の活動";
translations["MSG_PARENT_PAGE_NO_ACTIVITY_24H"] = "24時間以内の活動はありません";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY_24H"] = "最近24時間の活動";
translations["MSG_PARENT_PAGE_TODAY"] = "今日";
translations["MSG_PARENT_PAGE_YESTERDAY"] = "昨日";

// 保護者ページ - 活動タイプ
translations["MSG_ACTIVITY_COURSE_CLEAR"] = "%{course}のステージ%{stage} レベル%{level}をクリア！";
translations["MSG_ACTIVITY_PROJECT_CREATED"] = "「%{name}」を作成しました";
translations["MSG_ACTIVITY_PROJECT_PUBLISHED"] = "「%{name}」を公開しました";
translations["MSG_ACTIVITY_PROJECT_FAVORITED"] = "「%{name}」にいいねしました";
translations["MSG_ACTIVITY_FAVORITED_RECEIVED"] = "いいねをもらいました";
translations["MSG_ACTIVITY_LOGIN"] = "ログインしました";
translations["MSG_ACTIVITY_ICON_CHANGED"] = "アイコンを変更しました";
translations["MSG_ACTIVITY_AI_CHAT"] = "AIとお話ししました";
translations["MSG_ACTIVITY_INQUIRY_SENT"] = "問い合わせを送信しました";
translations["MSG_ACTIVITY_APP_REVIEWED"] = "アプリを★%{rating}で評価しました";
translations["MSG_ACTIVITY_FEEDBACK_SENT"] = "フィードバックを送信しました";
translations["MSG_ACTIVITY_COIN_EARNED"] = "%{amount}コインを獲得しました";
translations["MSG_ACTIVITY_COIN_SPENT"] = "%{amount}コインを使用しました";
translations["MSG_ACTIVITY_LOGIN_STREAK"] = "%{days}日連続ログイン達成！";
translations["MSG_ACTIVITY_DEFAULT"] = "活動しました";

// 保護者ページ - アクティビティログ（保護者向け・漢字統一）
translations["MSG_PARENT_PAGE_ACTIVITY_COURSE_CLEAR"] =
  "%{course}のステージ%{stage} レベル%{level}をクリア！";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_CREATED"] = "「%{name}」を作成しました";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_PUBLISHED"] = "「%{name}」を公開しました";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_FAVORITED"] = "「%{name}」にいいねしました";
translations["MSG_PARENT_PAGE_ACTIVITY_FAVORITED_RECEIVED"] = "いいねをもらいました";
translations["MSG_PARENT_PAGE_ACTIVITY_LOGIN"] = "ログインしました";
translations["MSG_PARENT_PAGE_ACTIVITY_ICON_CHANGED"] = "アイコンを変更しました";
translations["MSG_PARENT_PAGE_ACTIVITY_AI_CHAT"] = "AIとお話ししました";
translations["MSG_PARENT_PAGE_ACTIVITY_INQUIRY_SENT"] = "問い合わせを送信しました";
translations["MSG_PARENT_PAGE_ACTIVITY_APP_REVIEWED"] = "アプリを★%{rating}で評価しました";
translations["MSG_PARENT_PAGE_ACTIVITY_FEEDBACK_SENT"] = "フィードバックを送信しました";
translations["MSG_PARENT_PAGE_ACTIVITY_DEFAULT"] = "活動しました";

// 保護者ページ - 作品・素材セクション
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS"] = "作品一覧";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY"] = "まだアプリがありません";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS"] = "素材一覧";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_LIST"] = "素材一覧";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_EMPTY"] = "まだ素材がありません";
translations["MSG_PARENT_PAGE_PLAYER_SHOW_MORE"] = "もっと見る";
translations["MSG_PARENT_PAGE_PLAYER_ALBUM"] = "アルバム";
translations["MSG_PARENT_PAGE_PLAYER_SKETCHBOOK"] = "スケッチブック";
translations["MSG_PARENT_PAGE_PLAYER_AI_IMAGE"] = "AIがぞう";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_PUBLISHED"] = "公開中";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UNPUBLISHED"] = "未公開";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_VIEWS"] = "回閲覧";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_LIKES"] = "いいね";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_COPIES"] = "回コピー";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_CREATED"] = "作成日";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UPDATED"] = "更新日";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_CREATED"] = "作成日";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_SIZE"] = "サイズ";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_UNNAMED"] = "名前なし";

// 保護者ページ - フィードバック履歴
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY"] = "フィードバック履歴";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY"] = "まだフィードバックがありません";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_RATING"] = "アプリの評価";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_FEEDBACK"] = "フィードバック";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_CONTACT"] = "お問い合わせ";
translations["MSG_PARENT_PAGE_FEEDBACK_RATING_SUMMARY"] = "アプリを★%{rating}で評価しました";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_HOW_TO"] = "使い方について";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_BUG"] = "不具合報告";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_REQUEST"] = "機能リクエスト";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_OTHER"] = "その他";
translations["MSG_PARENT_PAGE_FEEDBACK_REPLIED"] = "返信済み";
translations["MSG_PARENT_PAGE_FEEDBACK_PENDING"] = "未返信";
translations["MSG_PARENT_PAGE_FEEDBACK_DETAIL"] = "フィードバック詳細";

// 保護者ページ - AIチャット履歴
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY"] = "まなパルくんとのおはなし履歴";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY"] = "まだおはなし履歴がありません";
translations["MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT"] = "%{count}件のメッセージ";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_TITLE"] = "タイトルなし";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_MESSAGES"] = "メッセージがありません";

// 保護者ページ - 課金管理タブ
translations["MSG_PARENT_PAGE_CURRENT_PLAN"] = "現在のプラン";
translations["MSG_PARENT_PAGE_MONTHLY_PRICE"] = "月額料金";
translations["MSG_PARENT_PAGE_ANNUAL_PRICE"] = "年額料金";
translations["MSG_PARENT_PAGE_PLAN_COMPARISON"] = "プラン比較";
translations["MSG_PARENT_PAGE_USER_COUNT"] = "プレイヤー数";
translations["MSG_PARENT_PAGE_PEOPLE"] = "人";
translations["MSG_PARENT_PAGE_PROJECT_COUNT"] = "「じゆうにつくる」の作品数";
translations["MSG_PARENT_PAGE_PROJECTS"] = "作品";
translations["MSG_PARENT_PAGE_AI_CHAT_FEATURE"] = "まなパルくんとのおはなし";
translations["MSG_PARENT_PAGE_AI_IMAGE_FEATURE"] = "AIで素材画像生成";
translations["MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT"] = "5回/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT"] = "2回/日";
translations["MSG_PARENT_PAGE_AI_CHAT_TAGLINE"] = "AIキャラクターと楽しく会話できる！";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1"] = "質問や相談に答えてくれる";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2"] = "お子様の好奇心を育む会話体験";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3"] = "アイデアの相談もできる";
translations["MSG_PARENT_PAGE_AI_IMAGE_TAGLINE"] = "想像したものを画像にできる！";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1"] = "オリジナルアイコンを作成";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2"] = "「じゆうにつくる」の素材に";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3"] = "チャットにも送れる";
translations["MSG_PARENT_PAGE_UNLIMITED"] = "無制限";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FEATURE"] = "会話履歴";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FREE_LIMIT"] = "100件まで";
translations["MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT"] = "無制限";
translations["MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT"] = "無制限";
translations["MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT"] = "無制限（同時1枚生成）";
translations["MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT"] = "無制限（同時3枚生成）";
translations["MSG_PARENT_PAGE_FREE"] = "無料";
translations["MSG_PARENT_PAGE_PLAN_INFO"] = "プラン情報";
translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "契約元";
translations["MSG_PARENT_PAGE_UPGRADE_SECTION"] = "プラン購入";
translations["MSG_PARENT_PAGE_SELECT_BILLING_PERIOD"] = "契約期間を選択";
// 保護者ページ - その他タブ
translations["MSG_PARENT_PAGE_DOWNLOAD_PARENTS_APP"] = "保護者アプリをダウンロード";
translations["MSG_PARENT_PAGE_APP_DESCRIPTION"] =
  "保護者アプリを使って、お子様の学習状況を確認したり、設定を管理できます。";
translations["MSG_PARENT_PAGE_LEARNING_SUPPORT"] = "学習サポート";
translations["MSG_PARENT_PAGE_COURSE_ANSWER"] = "コースの解答を見る";
translations["MSG_PARENT_PAGE_VIEW_TUTORIAL"] = "チュートリアルを見る";
translations["MSG_PARENT_PAGE_CORPORATE_CODE"] = "企業連携コード";
translations["MSG_PARENT_PAGE_ENABLE_CORPORATE"] = "企業認証コードを入力";
translations["MSG_PARENT_PAGE_CORPORATE_DESCRIPTION"] =
  "企業提携コードをお持ちの方は、こちらから入力してください。";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_DESCRIPTION"] =
  "『まなんでパズル』認証コード（企業提携コード）をお持ちの方は、下記に指定されたコードを入力してください。";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_CODE_INPUT"] = "認証コード入力";
translations["MSG_PARENT_PAGE_CORPORATE_CONFIRM"] = "決定";
translations["MSG_PARENT_PAGE_CORPORATE_ALLOWED_CONTENT"] = "許可されたコンテンツ（カセット）";
translations["MSG_PARENT_PAGE_CORPORATE_NO_CONTENT"] =
  "許可された追加コンテンツ（カセット）はありません。";
translations["MSG_PARENT_PAGE_DATE_FORMAT"] = "MM月DD日";
// 保護者ページ - お知らせタブ（デモデータ）
// 画像生成モーダル
translations["MSG_AI_PRESET_CAT"] = "ねこ";
translations["MSG_AI_PRESET_DOG"] = "いぬ";
translations["MSG_AI_PRESET_RABBIT"] = "うさぎ";
translations["MSG_AI_PRESET_BEAR"] = "くま";
translations["MSG_AI_PRESET_BIRD"] = "とり";
translations["MSG_AI_PRESET_NINJA"] = "にんじゃ";
translations["MSG_AI_PRESET_WIZARD"] = "まほう\nつかい";
translations["MSG_AI_PRESET_ROBOT"] = "ロボット";

// AI生成オプション（保護者向け - 漢字統一）
translations["MSG_OPTIONAL"] = "にんい";
translations["MSG_REQUIRED"] = "ひっす";
// 素材AI画像生成（自由入力）
translations["MSG_AI_MATERIAL_MODAL_TITLE"] = "AIがぞうをつくろう！";
translations["MSG_AI_MATERIAL_PROMPT_LABEL"] = "なにをつくる？";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_1"] = "かわいいいぬ";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_2"] = "はしって楽しそう";
translations["MSG_AI_MATERIAL_GENERATE_BUTTON"] = "つくる！";
// AIスタイル（9種類）
translations["MSG_AI_STYLE_CYBERPUNK"] = "サイバー\nパンク";
translations["MSG_AI_STYLE_ANIME"] = "アニメ";
translations["MSG_AI_STYLE_DRAMATIC"] = "ドラマチック";
translations["MSG_AI_STYLE_COLORING"] = "ぬりえ";
translations["MSG_AI_STYLE_PHOTO"] = "しゃしん";
translations["MSG_AI_STYLE_RETRO_MANGA"] = "レトロ\nまんが";
translations["MSG_AI_STYLE_EIGHTIES"] = "80ねんだい";
translations["MSG_AI_STYLE_ART_NOUVEAU"] = "アール\nヌーボー";
translations["MSG_AI_STYLE_SYNTHWAVE"] = "シンセ\nウェーブ";

// AI表情（4種類）
translations["MSG_AI_EXPRESSION_SMILE"] = "にこにこ";
translations["MSG_AI_EXPRESSION_COOL"] = "クール";
translations["MSG_AI_EXPRESSION_SLEEPY"] = "ねむい";
translations["MSG_AI_EXPRESSION_SURPRISED"] = "びっくり";

// AIアクセサリー（4種類）
translations["MSG_AI_ACCESSORY_HAT"] = "ぼうし";
translations["MSG_AI_ACCESSORY_GLASSES"] = "めがね";
translations["MSG_AI_ACCESSORY_RIBBON"] = "リボン";
translations["MSG_AI_ACCESSORY_CROWN"] = "おうかん";

// AI背景（4種類）
translations["MSG_AI_BACKGROUND_STARRY"] = "ほしぞら";
translations["MSG_AI_BACKGROUND_MEADOW"] = "くさはら";
translations["MSG_AI_BACKGROUND_SPACE"] = "うちゅう";
translations["MSG_AI_BACKGROUND_FLOWER"] = "おはな\nばたけ";

// AI加工 - タイプ
// AI加工 - ステップタイトル
// AI加工 - スタイルオプション
// AI加工 - 背景オプション
// AI加工 - コスプレオプション
// AI加工 - 動物オプション
// AI加工 - アクセサリーオプション
// AI加工 - 季節オプション
translations["MSG_TOAST_AI_GENERATION_FAILED"] = "AI画像の生成に失敗しました。";
// UserStock AI tab
translations["MSG_USER_STOCK_AI_TAB"] = "AIアトリエ";
translations["MSG_USER_STOCK_AI_TITLE"] = "AIアトリエ";
translations["MSG_USER_STOCK_AI_EMPTY"] = "AI で つくった がぞう は ないよ";
translations["MSG_USER_STOCK_AI_HINT"] =
  "AI せいせい と AI かこう で つくった がぞう が ここ に ついか されます";

// AIImageModal
translations["MSG_AI_IMAGE_SAVED"] = "AIがぞうを ほぞんしたよ";
translations["MSG_AI_TAB_GENERATE"] = "つくる";
// AIImageModal Player versions
// AI画像生成 制限メッセージ（EDUCATION用）
translations["MSG_AI_EDUCATION_LIMIT_TITLE"] = "つかえないよ";
translations["MSG_AI_EDUCATION_LIMIT_MESSAGE"] = "きょうしつプランでは このきのうは つかえないよ";
// AI画像生成 利用回数表示（FREE用）
translations["MSG_AI_IMAGE_PLAN_LABEL"] = "プラン";
translations["MSG_AI_IMAGE_USAGE_TODAY"] = "きょう %{remaining}/%{limit}かい";
translations["MSG_AI_IMAGE_UNLIMITED"] = "つかいほうだい";
translations["MSG_AI_IMAGE_COUNT_PER_REQUEST"] = "いっかいで %{count}まい";

// IconSelector
// IconSelector - InitialSelection（3択）
translations["MSG_ICON_SELECT_TITLE"] = "じぶんの アイコンを えらぼう！";
translations["MSG_ICON_SELECT_SYSTEM"] = "ようい された\nアイコン";
translations["MSG_ICON_SELECT_SYSTEM_DESC"] = "いろんな キャラクターから えらべるよ";
translations["MSG_ICON_SELECT_PROFILE_AI"] = "プロフィールで\nAIで じどうで\nつくる";
translations["MSG_ICON_SELECT_PROFILE_AI_DESC"] = "すきなことを いれると つくってくれるよ";
translations["MSG_ICON_SELECT_MATERIAL"] = "そざいから\nえらぶ";
translations["MSG_ICON_SELECT_MATERIAL_DESC"] = "がぞうを アップロード も できるよ";
// IconSelector - セクションタイトル
translations["MSG_SYSTEM_ICON_TITLE"] = "プリセットから えらぶ";
// IconSelector - カテゴリ
translations["MSG_ICON_CATEGORY_ALL"] = "すべて";
translations["MSG_ICON_CATEGORY_BOY"] = "おとこのこ";
translations["MSG_ICON_CATEGORY_GIRL"] = "おんなのこ";

translations["MSG_PROFILE_AI_GENDER_TITLE"] = "せいべつ";
translations["MSG_PROFILE_TAB_BASIC"] = "きほん";
translations["MSG_PROFILE_TAB_APPEARANCE"] = "みため";
translations["MSG_PROFILE_TAB_FAVORITES"] = "こせい";
translations["MSG_PROFILE_MULTI_SELECT"] = "いくつでも えらべるよ";
translations["MSG_PROFILE_NOT_SET"] = "まだ えらんでないよ";
translations["MSG_PROFILE_SELF_INTRODUCTION_NOT_SET"] = "まだ にゅうりょくしてないよ";
translations["MSG_PROFILE_CHANGE_BTN"] = "へんこう";
translations["MSG_PROFILE_EDIT_COLOR_TITLE"] = "すきな いろ を えらぼう";
translations["MSG_PROFILE_AI_OPTIONS_TITLE"] = "おこのみ";
translations["MSG_PROFILE_AI_FAVORITE_COLOR"] = "すきな いろ";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_PARENT"] = "好きな色";
translations["MSG_PROFILE_AI_FAVORITE_ANIMAL"] = "すきな どうぶつ";
translations["MSG_PROFILE_AI_OCCUPATION"] = "おしごと";
translations["MSG_PROFILE_AI_GENERATING"] = "つくってるよ...";
translations["MSG_PROFILE_AI_GENERATE_BTN"] = "あいこんを つくる！";
translations["MSG_PROFILE_AI_BEST_SUBJECTS"] = "とくいな きょうか";
translations["MSG_PROFILE_AI_GLASSES"] = "メガネ";
translations["MSG_PROFILE_AI_ACCESSORY"] = "みにつけるもの";
translations["MSG_PROFILE_AI_HAIRSTYLE"] = "かみがた";
translations["MSG_PROFILE_AI_BODY_TYPE"] = "たいけい";
translations["MSG_PROFILE_AI_FACE_SHAPE"] = "かおの かたち";
translations["MSG_PROFILE_EDIT_BEST_SUBJECTS_TITLE"] = "とくいな きょうかを えらんでね";
translations["MSG_PROFILE_EDIT_ACCESSORY_TITLE"] = "みにつけるものを えらんでね";
// 身につけるもの選択肢
translations["MSG_ACCESSORY_NONE"] = "なし";
translations["MSG_ACCESSORY_MEGANE"] = "めがね";
translations["MSG_ACCESSORY_BOUSHI"] = "ぼうし";
translations["MSG_ACCESSORY_HAIRPIN"] = "ヘアピン";
translations["MSG_ACCESSORY_RIBBON"] = "りぼん";
translations["MSG_ACCESSORY_BANDAID"] = "ばんそうこう";

translations["MSG_GENDER_MALE_PARENT"] = "男の子";
translations["MSG_GENDER_FEMALE_PARENT"] = "女の子";
translations["MSG_GENDER_OTHER_PARENT"] = "その他";

translations["MSG_COLOR_RED"] = "あか";
translations["MSG_COLOR_BLUE"] = "あお";
translations["MSG_COLOR_PINK"] = "ピンク";
translations["MSG_COLOR_GREEN"] = "みどり";
translations["MSG_COLOR_YELLOW"] = "きいろ";
translations["MSG_COLOR_PURPLE"] = "むらさき";
translations["MSG_COLOR_WHITE"] = "しろ";
// 色選択UI
translations["MSG_COLOR_SELECT_SHADE"] = "すきな いろみを えらんでね";
// IconSelector - 好きな動物選択肢
translations["MSG_ANIMAL_CAT"] = "ねこ";
translations["MSG_ANIMAL_DOG"] = "いぬ";
translations["MSG_ANIMAL_RABBIT"] = "うさぎ";
translations["MSG_ANIMAL_BEAR"] = "くま";
translations["MSG_ANIMAL_BIRD"] = "とり";
translations["MSG_ANIMAL_DINOSAUR"] = "きょうりゅう";
// IconSelector - 好きな食べ物選択肢
translations["MSG_FOOD_CURRY"] = "カレー";
translations["MSG_FOOD_RAMEN"] = "ラーメン";
translations["MSG_FOOD_SUSHI"] = "おすし";
translations["MSG_FOOD_HAMBURGER"] = "ハンバーグ";
translations["MSG_FOOD_PIZZA"] = "ピザ";
translations["MSG_FOOD_ICE_CREAM"] = "アイスクリーム";
translations["MSG_FOOD_FRUIT"] = "くだもの";
translations["MSG_FOOD_CAKE"] = "ケーキ";

// IconSelector - 得意なこと選択肢
translations["MSG_STRENGTH_SPORTS"] = "スポーツ";
translations["MSG_STRENGTH_DRAWING"] = "おえかき";
translations["MSG_STRENGTH_MUSIC"] = "おんがく";
translations["MSG_STRENGTH_READING"] = "どくしょ";
translations["MSG_STRENGTH_MATH"] = "さんすう";
translations["MSG_STRENGTH_GAMES"] = "ゲーム";
translations["MSG_STRENGTH_CRAFTS"] = "こうさく";
translations["MSG_STRENGTH_COOKING"] = "りょうり";

// IconSelector - 保護者向け性別選択肢
translations["MSG_GENDER_MALE_PARENT"] = "男性";
translations["MSG_GENDER_FEMALE_PARENT"] = "女性";
translations["MSG_GENDER_OTHER_PARENT"] = "その他";
translations["MSG_GENDER_PREFER_NOT_TO_SAY"] = "回答しない";
translations["MSG_GENDER_NOT_SPECIFIED"] = "未設定";

// IconSelector - プロフィールAI生成フォーム追加
translations["MSG_PROFILE_AI_BIRTHDAY_TITLE"] = "たんじょうび";
translations["MSG_PROFILE_AI_BIRTHDAY_SELECT"] = "えらんでね";
translations["MSG_PROFILE_AI_FAVORITE_FOOD"] = "すきな たべもの";
translations["MSG_PROFILE_AI_STRENGTH"] = "とくいな こと";
translations["MSG_PROFILE_AI_OTHER_INFO"] = "じこしょうかい";
translations["MSG_PROFILE_AI_OTHER_INFO_PLACEHOLDER"] = "じぶんのことを かいてね";
translations["MSG_PROFILE_AI_OCCUPATION_PLACEHOLDER"] = "例: 会社員、自営業など";

// 興味のある分野
translations["MSG_INTEREST_PROGRAMMING"] = "プログラミング";
translations["MSG_INTEREST_SCIENCE"] = "かがく";
translations["MSG_INTEREST_ART"] = "アート";
translations["MSG_INTEREST_MUSIC"] = "おんがく";
translations["MSG_INTEREST_SPORTS"] = "スポーツ";
translations["MSG_INTEREST_NATURE"] = "しぜん";
translations["MSG_INTEREST_SPACE"] = "うちゅう";
translations["MSG_INTEREST_ANIMALS"] = "どうぶつ";

translations["MSG_CREATE_USER_STEP_NAME"] = "なまえ";
translations["MSG_CREATE_USER_STEP_ICON"] = "アイコン";
translations["MSG_CREATE_USER_STEP_CONFIRM"] = "かくにん";

// CreateUserWizard - タイトル
translations["MSG_CREATE_USER_TITLE_GENDER"] = "きみは どっち？";
translations["MSG_CREATE_USER_TITLE_BIRTHDAY"] = "おたんじょうびは いつ？";
translations["MSG_CREATE_USER_TITLE_PREVIEW"] = "これで いいかな？";
// CreateUserWizard - ボタン
translations["MSG_CREATE_USER_BTN_NEXT"] = "つぎへ";
translations["MSG_CREATE_USER_BTN_GENERATE"] = "アイコンを つくる";
// CreateUserWizard - アイコン選択方法
// CreateUserWizard - プロフィール入力サブステップ名
translations["MSG_PROFILE_SUBSTEP_GENDER"] = "せいべつ";
translations["MSG_PROFILE_SUBSTEP_BIRTHDAY"] = "たんじょうび";
translations["MSG_PROFILE_SUBSTEP_FAVORITES"] = "すきなもの";
translations["MSG_PROFILE_SUBSTEP_ICON"] = "アイコン";
translations["MSG_ICON_GENERATING"] = "プロフィールをもとに\nアイコンをつくっているよ...";
translations["MSG_ICON_CONFIRM_PROMPT"] = "この アイコンで だいじょうぶ？";
translations["MSG_ICON_CONFIRM_BTN"] = "これでいい！";
translations["MSG_ICON_REGENERATE_BTN"] = "もういちど つくる";
translations["MSG_ICON_CREATE_BTN"] = "つくる";
translations["MSG_ICON_ADDITIONAL_PROMPT_PLACEHOLDER"] = "ついかしたい ことが あれば";
translations["MSG_ICON_ADDITIONAL_PROMPT_HINT"] =
  "すきな いろ や もの を にゅうりょくして もういちど つくれるよ！";

// IconSelector - フッターボタン
translations["MSG_REGENERATE_BTN"] = "もういちど つくる";
// CreateUserWizard - プロフィール入力タイトル
// CreateUserWizard - その他
// CreateUserWizard - 保護者用・子供追加用文言
// CreateUserWizard - 保護者用ボタン
// CreateUserWizard - アップロードアイコン（保護者用）
translations["MSG_ICON_SELECT_UPLOAD"] = "がぞうを\nアップロード";
translations["MSG_UPLOAD_ICON_TITLE"] = "がぞうを アップロードしてね";
translations["MSG_UPLOAD_ICON_SELECT"] = "がぞうを えらぶ";
translations["MSG_UPLOAD_ICON_HINT"] = "JPG、PNG けいしき、5MBまで";
translations["MSG_UPLOAD_ICON_CHANGE"] = "べつの がぞうに かえる";
translations["MSG_UPLOAD_ICON_REMOVE"] = "がぞうを けす";
// CreateUserWizard - 職業ステップ（保護者用）
// CreateUserWizard - 保護者用ステップ名
// CreateUserWizard - プロフィールサブステップ（保護者用）
// CreateUserWizard - 誕生日ステップ形式（子供用）
translations["MSG_BIRTHDAY_YEAR_SUFFIX"] = "ねん";
translations["MSG_BIRTHDAY_MONTH_SUFFIX"] = "がつ";
translations["MSG_BIRTHDAY_DAY_SUFFIX"] = "にち";
// フッターボタン用
// IconSelector - フッターボタン用
// NameInputStep用
// PresetIconStep タブラベル用
// BirthdayStep サフィックス用
// FavoritesStep用
// 色オプション用
// 動物オプション用
// 食べ物オプション用
// 得意なことオプション用
// 興味オプション用

translations["MSG_PROFILE_AI_BEST_SUBJECT"] = "とくいな きょうか";
translations["MSG_SUBJECT_LANGUAGE"] = "こくご";
translations["MSG_SUBJECT_MATH"] = "さんすう";
translations["MSG_SUBJECT_SCIENCE"] = "りか";
translations["MSG_SUBJECT_SOCIAL"] = "しゃかい";
translations["MSG_SUBJECT_MUSIC"] = "おんがく";
translations["MSG_SUBJECT_ART"] = "ずこう";
translations["MSG_SUBJECT_PE"] = "たいいく";
translations["MSG_SUBJECT_LIFE"] = "せいかつ";
translations["MSG_SUBJECT_HOME_EC"] = "かてい";
translations["MSG_SUBJECT_ETHICS"] = "どうとく";
translations["MSG_SUBJECT_ENGLISH"] = "えいご";
translations["MSG_SUBJECT_INTEGRATED"] = "そうごう";
translations["MSG_SUBJECT_SPECIAL_ACTIVITIES"] = "とっかつ";

// 得意な教科（保護者向け）

// Select共通
translations["MSG_SELECT_PLACEHOLDER"] = "えらんでね";

// みため
translations["MSG_PROFILE_AI_APPEARANCE"] = "みため";
translations["MSG_GLASSES_TITLE"] = "メガネ";
translations["MSG_GLASSES_NONE"] = "なし";
translations["MSG_GLASSES_YES"] = "あり";
translations["MSG_HAIRSTYLE_TITLE"] = "かみがた";
translations["MSG_HAIRSTYLE_VERY_SHORT"] = "かなりみじかめ";
translations["MSG_HAIRSTYLE_SHORT"] = "みじかめ";
translations["MSG_HAIRSTYLE_MEDIUM"] = "ふつう";
translations["MSG_HAIRSTYLE_SLIGHTLY_LONG"] = "ややながめ";
translations["MSG_HAIRSTYLE_LONG"] = "ながめ";
translations["MSG_BODY_TYPE_TITLE"] = "たいけい";
translations["MSG_BODY_TYPE_THIN"] = "ほそめ";
translations["MSG_BODY_TYPE_SLIGHTLY_THIN"] = "ややほそめ";
translations["MSG_BODY_TYPE_MEDIUM"] = "ふつう";
translations["MSG_BODY_TYPE_SLIGHTLY_CHUBBY"] = "ややふとめ";
translations["MSG_BODY_TYPE_CHUBBY"] = "ふとめ";
translations["MSG_FACE_SHAPE_TITLE"] = "かおのかたち";
translations["MSG_FACE_SHAPE_ROUND"] = "まるがた";
translations["MSG_FACE_SHAPE_OVAL"] = "たまごがた";
translations["MSG_FACE_SHAPE_OBLONG"] = "おもなが";
translations["MSG_FACE_SHAPE_SQUARE"] = "しかくがた";
translations["MSG_FACE_SHAPE_TRIANGLE"] = "さんかくがた";

// IconPreviewStep用
// StepProgressBar用
// ProfileSubStepBar用

// ParentOnboardingModal - 保護者初期設定（全て漢字）
// メインステップバー
translations["MSG_PARENT_ONBOARDING_STEP_NAME"] = "名前";
translations["MSG_PARENT_ONBOARDING_STEP_ICON"] = "アイコン";
translations["MSG_PARENT_ONBOARDING_STEP_COMPLETE"] = "確認";
// サブステップバー（プロフィール入力）
translations["MSG_PARENT_PROFILE_APPEARANCE"] = "見た目";
translations["MSG_PARENT_PROFILE_WORK"] = "就業状況";
translations["MSG_PARENT_PROFILE_REGION"] = "お住まい";
translations["MSG_PARENT_PROFILE_FAMILY"] = "家族構成";
translations["MSG_PARENT_ONBOARDING_NAME_PLACEHOLDER"] = "保護者";
translations["MSG_PARENT_ONBOARDING_NICKNAME_TITLE"] = "ニックネームを入力してください";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_LIMIT"] = "10文字まで";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_ERROR"] = "10文字以内で入力してください";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET"] = "用意された\nアイコン";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET_TITLE"] = "アイコンを選択してください";
translations["MSG_PARENT_ONBOARDING_ICON_METHOD_TITLE"] = "アイコンを選択してください";
translations["MSG_PARENT_ONBOARDING_ICON_PROFILE_AI"] = "AIで自動で\nプロフィールから\n作る";
translations["MSG_PARENT_ONBOARDING_ICON_UPLOAD"] = "画像を\nアップロード";
translations["MSG_PARENT_ONBOARDING_GENDER_TITLE"] = "性別";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_TITLE"] = "生年月日";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_SELECT"] = "選択";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_TITLE"] = "職業";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_OPTIONAL"] = "（任意）";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_PLACEHOLDER"] = "例：会社員、自営業";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_GENERATING"] = "生成中...";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_CONFIRM"] = "確認";
translations["MSG_PARENT_ONBOARDING_BTN_NEXT"] = "次へ";
translations["MSG_PARENT_ONBOARDING_BTN_BACK"] = "戻る";
translations["MSG_PARENT_ONBOARDING_BTN_GENERATE"] = "作成";
translations["MSG_PARENT_ONBOARDING_BTN_REGENERATE"] = "再生成";
translations["MSG_PARENT_ONBOARDING_BTN_CONFIRM"] = "確定";
translations["MSG_PARENT_ONBOARDING_BTN_COMPLETE"] = "完了";
translations["MSG_PARENT_ONBOARDING_UPLOAD_TITLE"] = "アイコンをアップロード";
translations["MSG_PARENT_ONBOARDING_UPLOAD_SELECT"] = "選択";
translations["MSG_PARENT_ONBOARDING_UPLOAD_HINT"] = "JPG、PNG（5MB以下）";
translations["MSG_PARENT_ONBOARDING_GENDER_MALE"] = "男性";
translations["MSG_PARENT_ONBOARDING_GENDER_FEMALE"] = "女性";
translations["MSG_PARENT_ONBOARDING_GENDER_NONE"] = "なし";
// 所属先
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_TITLE"] = "所属先";
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_PLACEHOLDER"] = "例：株式会社〇〇";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_TITLE"] = "役職";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_PLACEHOLDER"] = "例：課長、エンジニア";
// お住まいの地域
translations["MSG_PARENT_ONBOARDING_REGION_TITLE"] = "お住まいの地域";
// 家族構成
translations["MSG_PARENT_ONBOARDING_FAMILY_TITLE"] = "家族構成";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_SINGLE"] = "単身";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_COUPLE"] = "夫婦のみ";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_NUCLEAR"] = "核家族";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_EXTENDED"] = "三世代同居";
translations["MSG_PARENT_ONBOARDING_CHILDREN_COUNT_TITLE"] = "子どもの人数";
translations["MSG_PARENT_ONBOARDING_SPOUSE_TITLE"] = "配偶者";
translations["MSG_PARENT_ONBOARDING_SPOUSE_YES"] = "あり";
translations["MSG_PARENT_ONBOARDING_SPOUSE_NO"] = "なし";
// 年収
translations["MSG_PARENT_ONBOARDING_INCOME_TITLE"] = "世帯収入";
translations["MSG_PARENT_ONBOARDING_INCOME_UNDER_5M"] = "500万円未満";
translations["MSG_PARENT_ONBOARDING_INCOME_5M_10M"] = "500〜1000万円";
translations["MSG_PARENT_ONBOARDING_INCOME_OVER_10M"] = "1000万円以上";
translations["MSG_PARENT_ONBOARDING_INCOME_PREFER_NOT_TO_SAY"] = "回答しない";
// 趣味
translations["MSG_PARENT_ONBOARDING_HOBBIES_TITLE"] = "趣味";
translations["MSG_PARENT_ONBOARDING_HOBBIES_HINT"] = "複数選択可能";
translations["MSG_PARENT_ONBOARDING_HOBBIES_SPORTS"] = "スポーツ";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MUSIC"] = "音楽";
translations["MSG_PARENT_ONBOARDING_HOBBIES_READING"] = "読書";
translations["MSG_PARENT_ONBOARDING_HOBBIES_TRAVEL"] = "旅行";
translations["MSG_PARENT_ONBOARDING_HOBBIES_COOKING"] = "料理";
translations["MSG_PARENT_ONBOARDING_HOBBIES_GAMING"] = "ゲーム";
translations["MSG_PARENT_ONBOARDING_HOBBIES_OUTDOOR"] = "アウトドア";
translations["MSG_PARENT_ONBOARDING_HOBBIES_ART"] = "アート";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MOVIES"] = "映画";
translations["MSG_PARENT_ONBOARDING_HOBBIES_PHOTOGRAPHY"] = "写真";
// 自由入力
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_TITLE"] = "自己紹介";
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_PLACEHOLDER"] =
  "趣味、特技、お子様の年齢など、自由にご記入ください";

// CreateUserWizard - プロフィール項目「その他」入力欄

// 保護者プロフィール - 容姿

// 保護者プロフィール - お勤め先
translations["MSG_COMPANY_SIZE_TITLE"] = "会社規模";
translations["MSG_COMPANY_SIZE_SOLO"] = "個人事業主";
translations["MSG_COMPANY_SIZE_MICRO"] = "1-10人";
translations["MSG_COMPANY_SIZE_SMALL"] = "11-50人";
translations["MSG_COMPANY_SIZE_MEDIUM"] = "51-300人";
translations["MSG_COMPANY_SIZE_LARGE"] = "301-1000人";
translations["MSG_COMPANY_SIZE_ENTERPRISE"] = "1001人以上";
translations["MSG_INDUSTRY_TITLE"] = "業種";
translations["MSG_INDUSTRY_IT"] = "IT・通信";
translations["MSG_INDUSTRY_MANUFACTURING"] = "製造業";
translations["MSG_INDUSTRY_FINANCE"] = "金融・保険";
translations["MSG_INDUSTRY_RETAIL"] = "小売・卸売";
translations["MSG_INDUSTRY_HEALTHCARE"] = "医療・福祉";
translations["MSG_INDUSTRY_EDUCATION"] = "教育";
translations["MSG_INDUSTRY_GOVERNMENT"] = "官公庁・公務員";
translations["MSG_INDUSTRY_REAL_ESTATE"] = "不動産";
translations["MSG_INDUSTRY_CONSTRUCTION"] = "建設";
translations["MSG_INDUSTRY_TRANSPORTATION"] = "運輸・物流";
translations["MSG_INDUSTRY_MEDIA"] = "メディア・広告";
translations["MSG_INDUSTRY_SERVICE"] = "サービス業";
translations["MSG_INDUSTRY_OTHER"] = "その他";
translations["MSG_OCCUPATION_TITLE"] = "職種";
translations["MSG_OCCUPATION_EXECUTIVE"] = "経営者・役員";
translations["MSG_OCCUPATION_MANAGER"] = "管理職";
translations["MSG_OCCUPATION_ENGINEER"] = "エンジニア・技術職";
translations["MSG_OCCUPATION_SALES"] = "営業";
translations["MSG_OCCUPATION_MARKETING"] = "マーケティング";
translations["MSG_OCCUPATION_HR"] = "人事";
translations["MSG_OCCUPATION_ACCOUNTING"] = "経理・財務";
translations["MSG_OCCUPATION_RESEARCHER"] = "研究職";
translations["MSG_OCCUPATION_TEACHER"] = "教員";
translations["MSG_OCCUPATION_DOCTOR"] = "医師";
translations["MSG_OCCUPATION_NURSE"] = "看護師";
translations["MSG_OCCUPATION_LAWYER"] = "弁護士";
translations["MSG_OCCUPATION_DESIGNER"] = "デザイナー";
translations["MSG_OCCUPATION_FREELANCE"] = "フリーランス";
translations["MSG_OCCUPATION_HOMEMAKER"] = "専業主婦・主夫";
translations["MSG_OCCUPATION_STUDENT"] = "学生";
translations["MSG_OCCUPATION_OTHER"] = "その他";
// 保護者プロフィール - 役職
translations["MSG_JOB_TITLE_LABEL"] = "役職・立場";
translations["MSG_JOB_TITLE_EXECUTIVE"] = "経営者・役員";
translations["MSG_JOB_TITLE_MANAGER"] = "管理職";
translations["MSG_JOB_TITLE_GENERAL"] = "一般職";
translations["MSG_JOB_TITLE_PROFESSIONAL"] = "専門職";
translations["MSG_JOB_TITLE_HOMEMAKER"] = "役職なし（専業主婦／主夫）";
translations["MSG_JOB_TITLE_STUDENT"] = "役職なし（学生）";
translations["MSG_JOB_TITLE_UNEMPLOYED"] = "役職なし（無職）";

// 保護者プロフィール - 住所
translations["MSG_PREFECTURE_TITLE"] = "都道府県";
translations["MSG_CITY_TITLE"] = "地域";
// 保護者プロフィール - 家族構成
translations["MSG_HOUSEHOLD_MEMBERS_TITLE"] = "同居人";
translations["MSG_HOUSEHOLD_MEMBER_MOTHER"] = "母親";
translations["MSG_HOUSEHOLD_MEMBER_FATHER"] = "父親";
translations["MSG_HOUSEHOLD_MEMBER_GRANDMOTHER"] = "祖母";
translations["MSG_HOUSEHOLD_MEMBER_GRANDFATHER"] = "祖父";
translations["MSG_BOYS_COUNT"] = "男の子";
translations["MSG_GIRLS_COUNT"] = "女の子";

translations["MSG_TOAST_PROJECT_QUOTA_EXCEEDED"] = "アプリの じょうげんに たっしました";
translations["MSG_CREATOR_APP_LIMIT"] = "アプリを つくれません";
translations["MSG_CREATOR_APP_LIMIT_TITLE"] = "アプリを つくれません";
translations["MSG_CREATOR_APP_LIMIT_MESSAGE"] =
  "いま つかっている プランでは アプリを %{limit}こ まで つくれます\nあたらしい アプリを つくるには いらない アプリを けしてください";
translations["MSG_CREATOR_TUTORIAL_LIMIT"] = "ガイドを うごかせません";
translations["MSG_CREATOR_TUTORIAL_LIMIT_TITLE"] = "ガイドを うごかせません";
translations["MSG_CREATOR_TUTORIAL_LIMIT_MESSAGE"] =
  "いま つかっている プランでは アプリを %{limit}こ まで つくれます\nあたらしい アプリを つくるには いらない アプリを けしてください";
translations["MSG_TOAST_AI_QUOTA_EXCEEDED"] = "きょうの AIは おわりです";
translations["MSG_TOAST_AI_ACCESS_DENIED"] = "このきのうは つかえません";
translations["MSG_ERROR_NETWORK"] = "ネットワーク エラー";
translations["MSG_TOAST_ERROR"] = "エラーが はっせいしました";
translations["MSG_TOAST_FILE_TOO_LARGE"] = "ファイルが おおきすぎます";
translations["MSG_PARENT_PAGE_EDIT_BEST_SUBJECT"] = "得意教科を編集";
translations["MSG_PARENT_PAGE_EDIT_GLASSES"] = "メガネを編集";
translations["MSG_PARENT_PAGE_EDIT_HAIRSTYLE"] = "髪型を編集";
translations["MSG_PARENT_PAGE_EDIT_BODY_TYPE"] = "体型を編集";
translations["MSG_PARENT_PAGE_EDIT_FACE_SHAPE"] = "顔の形を編集";
translations["MSG_SUBJECT_JAPANESE"] = "こくご";

// 保護者ページ - チャット画像機能制限
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_TITLE"] = "画像機能について";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_MESSAGE"] =
  "画像の送信は「特別プラン」で使えます\n特別プランにアップグレードすると、画像を送ることができます";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_BTN"] = "プランを見る";

translations["MSG_AI_LABEL"] = "AI";
translations["MSG_BUILDER_MAP_NAME_PLACEHOLDER"] = "マップの なまえ";
translations["MSG_BUILDER_TEST_BTN"] = "テスト";
translations["MSG_BUILDER_ASSET_LIST_TITLE"] = "パーツを えらぼう";
translations["MSG_BUILDER_ASSET_CATEGORY_DECORATION"] = "かざり";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND"] = "じめん";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND_HINT"] = "じめんの たかさに おけるよ";
translations["MSG_BUILDER_BLOCKLY_SETTINGS_TITLE"] = "つかえる ブロック";
translations["MSG_BUILDER_BLOCKLY_CATEGORY_MOTION"] = "うごき";
translations["MSG_BUILDER_BLOCKLY_CATEGORY_CONTROL"] = "くりかえし";
translations["MSG_BUILDER_BLOCK_MOVE_FORWARD"] = "まえに すすむ";
translations["MSG_BUILDER_BLOCK_TURN_LEFT"] = "ひだりを むく";
translations["MSG_BUILDER_BLOCK_TURN_RIGHT"] = "みぎを むく";
translations["MSG_BUILDER_BLOCK_JUMP"] = "ジャンプ";
translations["MSG_BUILDER_BLOCK_LOOP"] = "○かい くりかえす";
translations["MSG_BUILDER_BLOCK_IF_COLOR"] = "もし ○いろ なら";
translations["MSG_BUILDER_BLOCK_WHILE_COLOR"] = "○いろ まで くりかえす";
translations["MSG_BUILDER_BLOCKLY_SELECTED_COUNT"] = "%{count}この ブロックを せんたくちゅう";
translations["MSG_OK_BTN"] = "OK";
translations["MSG_BUILDER_AI_MAP_TITLE"] = "AIで マップを つくる";
translations["MSG_BUILDER_AI_PROMPT_LABEL"] = "どんな マップに する？（なくても OK）";
translations["MSG_BUILDER_AI_PROMPT_PLACEHOLDER"] = "れい: めいろ みたいな ステージ";
translations["MSG_BUILDER_DIFFICULTY_LABEL"] = "むずかしさ";
translations["MSG_BUILDER_DIFFICULTY_EASY"] = "かんたん";
translations["MSG_BUILDER_DIFFICULTY_MEDIUM"] = "ふつう";
translations["MSG_BUILDER_DIFFICULTY_HARD"] = "むずかしい";
translations["MSG_BUILDER_AI_GENERATING"] = "つくって います...";
translations["MSG_BUILDER_AI_GENERATION_FAILED"] = "マップの せいせいに しっぱいしました";
translations["MSG_CHAT_NEW_BADGE"] = "New";
translations["MSG_CHAT_LOAD_MORE"] = "もっと みる";

translations["MSG_CHAT_SEND_FAILED_MESSAGE"] = "メッセージの そうしんに しっぱいしました";

translations["MSG_CREATOR_DEFAULT_CHECK_APP"] = "アプリを\nチェック";
translations["MSG_CREATOR_DEFAULT_CREATE_APP"] = "アプリを つくる";
translations["MSG_CREATOR_DEFAULT_SEARCH_APP"] = "アプリを さがす";

// Guest Login Prompt Dialog
translations["MSG_GUEST_LOGIN_PROMPT_TITLE"] = "とうろくしてね";
translations["MSG_GUEST_LOGIN_PROMPT_MESSAGE"] =
  "たいけんばんを つかってくれて ありがとう！\nアカウントを つくると、もっと べんりに つかえるよ。";
translations["MSG_GUEST_LOGIN_PROMPT_BENEFITS_TITLE"] = "とうろくすると できること：";
translations["MSG_GUEST_LOGIN_PROMPT_BENEFITS"] =
  "がくしゅうデータを ほぞんできる\nおこさまを ついかできる\nすべての コースで あそべる";

export default translations;
